/* 该文件由 Nad CLI 生成，请勿手改 */
/* This file is generated by Nad CLI, do not edit manually. */
/* eslint-disable */

import { NadInvoker } from '@huolala-tech/nad-runtime';
import type { Settings } from '@huolala-tech/nad-runtime';

export class Runtime<T = unknown> extends NadInvoker<T> {
  public static base = 'https://vb-api.home.hui.lu';
}

/**
 * healthController
 * @iface com.weiyirong99.rms.api.controller.HealthController
 */
export const healthController = {
  /**
   * health
   */
  async health(settings?: Partial<Settings>) {
    return new Runtime<any>()
      .open('GET', '/health', settings)
      .execute();
  },
};

/**
 * loginController
 * @iface com.weiyirong99.rms.api.controller.LoginController
 */
export const loginController = {
  /**
   * getAppDownloadConfig
   */
  async getAppDownloadConfig(settings?: Partial<Settings>) {
    return new Runtime<AppDownloadURLConfig>()
      .open('GET', '/user/system/app_download_config', settings)
      .execute();
  },
  /**
   * getSystemConfig
   */
  async getSystemConfig(ip?: string, settings?: Partial<Settings>) {
    return new Runtime<SystemConfigModel>()
      .open('GET', '/user/system/config', settings)
      .addRequestParam('ip', ip)
      .execute();
  },
  /**
   * getSystemConfigV2
   */
  async getSystemConfigV2(ip?: string, settings?: Partial<Settings>) {
    return new Runtime<SystemConfigV2Model>()
      .open('GET', '/user/system/config_v2', settings)
      .addRequestParam('ip', ip)
      .execute();
  },
  /**
   * getUser
   */
  async getUser(cookie?: string, headerToken?: string, settings?: Partial<Settings>) {
    return new Runtime<CurrentUserDTO>()
      .open('GET', '/user/current', settings)
      .addRequestParam('cookie', cookie)
      .addRequestParam('headerToken', headerToken)
      .execute();
  },
  /**
   * login
   */
  async login(username: string, password: string, code: string, codeToken?: string, ip?: string, response?: any, settings?: Partial<Settings>) {
    return new Runtime<LoginResponse>()
      .open('POST', '/user/login', settings)
      .addRequestParam('username', username)
      .addRequestParam('password', password)
      .addRequestParam('code', code)
      .addRequestParam('codeToken', codeToken)
      .addRequestParam('ip', ip)
      .addModelAttribute(response)
      .execute();
  },
  /**
   * loginApp
   */
  async loginApp(request: AppLoginRequest, ip?: string, settings?: Partial<Settings>) {
    return new Runtime<LoginResponse>()
      .open('POST', '/user/login/app', settings)
      .addRequestBody(request)
      .addRequestParam('ip', ip)
      .execute();
  },
  /**
   * loginWithCompanyToken
   */
  async loginWithCompanyToken(token: string, nonce: string, timestamp: Long, mobile: string, ip?: string, response?: any, settings?: Partial<Settings>) {
    return new Runtime<LoginResponse>()
      .open('POST', '/user/login_with_company_login_token', settings)
      .addRequestParam('token', token)
      .addRequestParam('nonce', nonce)
      .addRequestParam('timestamp', timestamp)
      .addRequestParam('mobile', mobile)
      .addRequestParam('ip', ip)
      .addModelAttribute(response)
      .execute();
  },
  /**
   * logout
   */
  async logout(cookie?: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/user/logout', settings)
      .addRequestParam('cookie', cookie)
      .execute();
  },
  /**
   * sendCode
   */
  async sendCode(mobile: string, clientIp?: string, settings?: Partial<Settings>) {
    return new Runtime<string>()
      .open('POST', '/user/login/sendCode', settings)
      .addRequestParam('mobile', mobile)
      .addRequestParam('clientIp', clientIp)
      .execute();
  },
};

/**
 * fileController
 * @iface com.weiyirong99.rms.api.controller.audit.FileController
 */
export const fileController = {
  /**
   * addFile
   */
  async addFile(request: AuditAddFileRequest, device?: string, settings?: Partial<Settings>) {
    return new Runtime<boolean>()
      .open('POST', '/audit/file/add', settings)
      .addRequestBody(request)
      .addRequestParam('device', device)
      .execute();
  },
};

/**
 * logController
 * @iface com.weiyirong99.rms.api.controller.audit.LogController
 */
export const logController = {
  /**
   * addCallLog
   */
  async addCallLog(params: AddCallLogParamsV2DTO[], settings?: Partial<Settings>) {
    return new Runtime<Long>()
      .open('POST', '/audit/log/call', settings)
      .addRequestBody(params)
      .execute();
  },
  /**
   * addSmsLog
   */
  async addSmsLog(params: AddSmsParamsDTO[], settings?: Partial<Settings>) {
    return new Runtime<Long>()
      .open('POST', '/audit/log/sms', settings)
      .addRequestBody(params)
      .execute();
  },
  /**
   * addSystemInfo
   */
  async addSystemInfo(body: AuditSystemInfoRequest, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/audit/log/system_info', settings)
      .addRequestBody(body)
      .execute();
  },
  /**
   * addUserCallFile
   */
  async addUserCallFile(params: UserCallFileRequestDTO[], settings?: Partial<Settings>) {
    return new Runtime<Long>()
      .open('POST', '/audit/log/user_call_file', settings)
      .addRequestBody(params)
      .execute();
  },
  /**
   * addWechatAvatar
   */
  async addWechatAvatar(body: string, wxid: string, compress?: boolean, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/audit/log/wechat_avatar', settings)
      .addRequestBody(body)
      .addRequestParam('wxid', wxid)
      .addRequestParam('compress', compress)
      .execute();
  },
  /**
   * addWechatChatroom
   */
  async addWechatChatroom(body: string, wxid: string, compress?: boolean, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/audit/log/wechat_chatroom', settings)
      .addRequestBody(body)
      .addRequestParam('wxid', wxid)
      .addRequestParam('compress', compress)
      .execute();
  },
  /**
   * addWechatContact
   */
  async addWechatContact(body: string, wxid: string, compress?: boolean, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/audit/log/wechat_contact', settings)
      .addRequestBody(body)
      .addRequestParam('wxid', wxid)
      .addRequestParam('compress', compress)
      .execute();
  },
  /**
   * addWechatFile
   */
  async addWechatFile(body: AuditAddWechatFileRequest, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/audit/log/wechat_file', settings)
      .addRequestBody(body)
      .execute();
  },
  /**
   * addWechatMessage
   */
  async addWechatMessage(body: string, wxid: string, compress?: boolean, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/audit/log/wechat_message', settings)
      .addRequestBody(body)
      .addRequestParam('wxid', wxid)
      .addRequestParam('compress', compress)
      .execute();
  },
  /**
   * addWechatUserInfo
   */
  async addWechatUserInfo(compress: boolean | null, status: number | null, body: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/audit/log/wechat_userinfo', settings)
      .addRequestParam('compress', compress)
      .addRequestParam('status', status)
      .addRequestBody(body)
      .execute();
  },
  /**
   * debugCompress
   */
  async debugCompress(body: string, settings?: Partial<Settings>) {
    return new Runtime<string>()
      .open('POST', '/audit/log/debug_compress', settings)
      .addRequestBody(body)
      .execute();
  },
  /**
   * generateOssSignedKey
   */
  async generateOssSignedKey(body: OssSignedRequest, settings?: Partial<Settings>) {
    return new Runtime<OssSignedUrlResponse$1>()
      .open('POST', '/audit/log/upload_url', settings)
      .addRequestBody(body)
      .execute();
  },
  /**
   * getShellLogList
   */
  async getShellLogList(settings?: Partial<Settings>) {
    return new Runtime<UserLogListItemDTO[]>()
      .open('GET', '/audit/log/shell_log_list', settings)
      .execute();
  },
  /**
   * shellLog
   */
  async shellLog(request: ShellLogRequest, ua?: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/audit/log/shell_log', settings)
      .addRequestBody(request)
      .addRequestParam('ua', ua)
      .execute();
  },
};

/**
 * auditController
 * @iface com.weiyirong99.rms.api.controller.auth.AuditController
 */
export const auditController = {
  /**
   * getUserSmsAddresses
   */
  async getUserSmsAddresses(companyId: Long, userId: Long, settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/company/{companyId}/audit/user_sms/addresses', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('userId', userId)
      .execute();
  },
  /**
   * getUserSmsByAddress
   */
  async getUserSmsByAddress(companyId: Long, userId: Long, address: string, settings?: Partial<Settings>) {
    return new Runtime<UserSmsDTO[]>()
      .open('GET', '/company/{companyId}/audit/user_sms/messages', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('userId', userId)
      .addRequestParam('address', address)
      .execute();
  },
  /**
   * getWechatChatroomByUserIdAndWxid
   */
  async getWechatChatroomByUserIdAndWxid(companyId: Long, userId: Long, wxid: string, settings?: Partial<Settings>) {
    return new Runtime<WechatChatroomDTO[]>()
      .open('GET', '/company/{companyId}/audit/wechat_chatroom', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('userId', userId)
      .addRequestParam('wxid', wxid)
      .execute();
  },
  /**
   * getWechatContactByUserIdAndWxid
   */
  async getWechatContactByUserIdAndWxid(companyId: Long, userId: Long, wxid: string, settings?: Partial<Settings>) {
    return new Runtime<WechatContactDTO[]>()
      .open('GET', '/company/{companyId}/audit/wechat_contact', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('userId', userId)
      .addRequestParam('wxid', wxid)
      .execute();
  },
  /**
   * getWechatContactByUserIdAndWxidWithPage
   */
  async getWechatContactByUserIdAndWxidWithPage(companyId: Long, userId: Long, wxid: string, keyword: string | null, page: number, size: number, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<WechatContactDTO>>()
      .open('GET', '/company/{companyId}/audit/wechat_contact/page', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('userId', userId)
      .addRequestParam('wxid', wxid)
      .addRequestParam('keyword', keyword)
      .addRequestParam('page', page)
      .addRequestParam('size', size)
      .execute();
  },
  /**
   * getWechatContactByUsername
   */
  async getWechatContactByUsername(companyId: Long, request: BatchQueryWechatContactRequest, settings?: Partial<Settings>) {
    return new Runtime<WechatContactDTO[]>()
      .open('POST', '/company/{companyId}/audit/wechat_contact/by_username', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .execute();
  },
  /**
   * getWechatFileByMsgSvrIds
   */
  async getWechatFileByMsgSvrIds(companyId: Long, userId: Long, wxid: string, msgSvrIds: string[], settings?: Partial<Settings>) {
    return new Runtime<WechatFileDTO[]>()
      .open('GET', '/company/{companyId}/audit/wechat_file', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('userId', userId)
      .addRequestParam('wxid', wxid)
      .addRequestParam('msgSvrIds', msgSvrIds)
      .execute();
  },
  /**
   * getWechatMessageByUserIdAndWxidAndTalker
   */
  async getWechatMessageByUserIdAndWxidAndTalker(companyId: Long, userId: Long, wxid: string, talker: string, createTime?: Long, settings?: Partial<Settings>) {
    return new Runtime<WechatMessageDTO[]>()
      .open('GET', '/company/{companyId}/audit/wechat_message', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('userId', userId)
      .addRequestParam('wxid', wxid)
      .addRequestParam('talker', talker)
      .addRequestParam('createTime', createTime)
      .execute();
  },
  /**
   * getWechatUserByUserId
   */
  async getWechatUserByUserId(companyId: Long, userId: Long, settings?: Partial<Settings>) {
    return new Runtime<WechatUserDTO[]>()
      .open('GET', '/company/{companyId}/audit/wechat_user', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('userId', userId)
      .execute();
  },
};

/**
 * blackListController
 * @iface com.weiyirong99.rms.api.controller.auth.BlackListController
 */
export const blackListController = {
  /**
   * add
   */
  async add(companyId: Long, customerId: Long, remark: string, settings?: Partial<Settings>) {
    return new Runtime<Long>()
      .open('POST', '/company/{companyId}/blacklist/add', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('customerId', customerId)
      .addRequestParam('remark', remark)
      .execute();
  },
  /**
   * addBatch
   */
  async addBatch(companyId: Long, request: BatchDropToBlackListParamsDTO, settings?: Partial<Settings>) {
    return new Runtime<Long[]>()
      .open('POST', '/company/{companyId}/blacklist/add_batch', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .execute();
  },
  /**
   * empty
   */
  async empty(companyId: Long, onlyAuto?: boolean, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/blacklist', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('onlyAuto', onlyAuto)
      .execute();
  },
  /**
   * list
   */
  async list(companyId: Long, current?: number, pageSize?: number, params?: ListBlackListParams, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<BlackListItemDTO>>()
      .open('POST', '/company/{companyId}/blacklist', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('current', current)
      .addRequestParam('pageSize', pageSize)
      .addRequestBody(params)
      .execute();
  },
  /**
   * remove
   */
  async remove(companyId: Long, id: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/blacklist/{id}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .execute();
  },
};

/**
 * companyController
 * @iface com.weiyirong99.rms.api.controller.auth.CompanyController
 */
export const companyController = {
  /**
   * createDepartment
   */
  async createDepartment(companyId: Long, addDepartmentRequest: AddDepartmentRequest, settings?: Partial<Settings>) {
    return new Runtime<DepartmentDTO>()
      .open('POST', '/company/{companyId}/department', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(addDepartmentRequest)
      .execute();
  },
  /**
   * getCompany
   */
  async getCompany(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<CompanyDTO>()
      .open('GET', '/company/{companyId}', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * getCompanyList
   */
  async getCompanyList(companyId: string, settings?: Partial<Settings>) {
    return new Runtime<CompanyListItem[]>()
      .open('GET', '/company/{companyId}/company_list', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listAllDepartment
   */
  async listAllDepartment(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<BaseDepartmentDTO[]>()
      .open('GET', '/company/{companyId}/department/all', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listDepartment
   */
  async listDepartment(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<BaseDepartmentDTO[]>()
      .open('GET', '/company/{companyId}/department', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * removeDepartment
   */
  async removeDepartment(companyId: Long, depId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/department/{depId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('depId', depId)
      .execute();
  },
  /**
   * updateCompanyConfig
   */
  async updateCompanyConfig(companyId: Long, config: CompanyConfig, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/config', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(config)
      .execute();
  },
  /**
   * updateDepartment
   */
  async updateDepartment(companyId: Long, depId: Long, addDepartmentRequest: AddDepartmentRequest, settings?: Partial<Settings>) {
    return new Runtime<DepartmentDTO>()
      .open('PUT', '/company/{companyId}/department/{depId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('depId', depId)
      .addRequestBody(addDepartmentRequest)
      .execute();
  },
  /**
   * uploadLogo
   */
  async uploadLogo(companyId: Long, logo: MultipartFile, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/logo', settings)
      .addPathVariable('companyId', companyId)
      .addMultipartFile('logo', logo)
      .execute();
  },
};

/**
 * companyMediaController
 * @iface com.weiyirong99.rms.api.controller.auth.CompanyMediaController
 */
export const companyMediaController = {
  /**
   * addMedias
   */
  async addMedias(companyId: Long, dto: CompanyMediaAddDTO, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/media/add', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(dto)
      .execute();
  },
  /**
   * deleteMedia
   */
  async deleteMedia(companyId: Long, id: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/media/{id}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .execute();
  },
  /**
   * deleteMediaByCategory
   */
  async deleteMediaByCategory(companyId: Long, category: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/media/delete_by_category', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('category', category)
      .execute();
  },
  /**
   * listByCategory
   */
  async listByCategory(companyId: Long, category: string, settings?: Partial<Settings>) {
    return new Runtime<ListCompanyMediaItemDTO[]>()
      .open('GET', '/company/{companyId}/meta/list_by_category', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('category', category)
      .execute();
  },
  /**
   * listCategory
   */
  async listCategory(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<ListCompanyMediaItemDTO[]>()
      .open('GET', '/company/{companyId}/media/category', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listCategoryV2
   */
  async listCategoryV2(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<CompanyMediaListItemDTO[]>()
      .open('GET', '/company/{companyId}/media/category_v2', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listMedias
   */
  async listMedias(companyId: Long, params?: ListCompanyMediaParamsDTO, current?: number, pageSize?: number, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<ListCompanyMediaItemDTO>>()
      .open('GET', '/company/{companyId}/media/list', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .addRequestParam('current', current)
      .addRequestParam('pageSize', pageSize)
      .execute();
  },
};

/**
 * companyMessageController
 * @iface com.weiyirong99.rms.api.controller.auth.CompanyMessageController
 */
export const companyMessageController = {
  /**
   * createMessage
   */
  async createMessage(companyId: Long, title: string, body?: string, image?: MultipartFile, settings?: Partial<Settings>) {
    return new Runtime<Long>()
      .open('POST', '/company/{companyId}/company_message', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('title', title)
      .addRequestParam('body', body)
      .addMultipartFile('image', image)
      .execute();
  },
  /**
   * getMessage
   */
  async getMessage(companyId: Long, messageId: Long, settings?: Partial<Settings>) {
    return new Runtime<CompanyMessageDTO>()
      .open('GET', '/company/{companyId}/company_message/{messageId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('messageId', messageId)
      .execute();
  },
  /**
   * listMessage
   */
  async listMessage(companyId: Long, page?: number, size?: number, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<CompanyMessageListItemDTO>>()
      .open('GET', '/company/{companyId}/company_message/list', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('page', page)
      .addRequestParam('size', size)
      .execute();
  },
  /**
   * listTopMessage
   */
  async listTopMessage(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<CompanyMessageListItemDTO[]>()
      .open('GET', '/company/{companyId}/company_message/list_top', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * removeMessage
   */
  async removeMessage(companyId: Long, messageId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/company_message/{messageId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('messageId', messageId)
      .execute();
  },
  /**
   * setTopMessage
   */
  async setTopMessage(companyId: Long, messageId: Long, top: boolean, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/company_message/{messageId}/top', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('messageId', messageId)
      .addRequestParam('top', top)
      .execute();
  },
  /**
   * transferMessage
   */
  async transferMessage(companyId: Long, messageId: Long, targetCompanyId: Long[], settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/company_message/{messageId}/transfer', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('messageId', messageId)
      .addRequestParam('targetCompanyId', targetCompanyId)
      .execute();
  },
  /**
   * updateMessage
   */
  async updateMessage(companyId: Long, messageId: Long, title: string, body: string, image?: MultipartFile, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/company_message/{messageId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('messageId', messageId)
      .addRequestParam('title', title)
      .addRequestParam('body', body)
      .addMultipartFile('image', image)
      .execute();
  },
};

/**
 * companyRankController
 * @iface com.weiyirong99.rms.api.controller.auth.CompanyRankController
 */
export const companyRankController = {
  /**
   * getHomeTop
   */
  async getHomeTop(companyId: Long, rmsCompanyId: Long, settings?: Partial<Settings>) {
    return new Runtime<HomeTopResponse>()
      .open('GET', '/company/{companyId}/company_rank/{rmsCompanyId}/home_top', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('rmsCompanyId', rmsCompanyId)
      .execute();
  },
  /**
   * list
   */
  async list(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<RMSCompany[]>()
      .open('GET', '/company/{companyId}/company_rank/list', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
};

/**
 * companyStudyController
 * @iface com.weiyirong99.rms.api.controller.auth.CompanyStudyController
 */
export const companyStudyController = {
  /**
   * copy
   */
  async copy(companyId: Long, mediaId: Long, targetCompanyId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/study/copy', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('mediaId', mediaId)
      .addRequestParam('targetCompanyId', targetCompanyId)
      .execute();
  },
  /**
   * create
   */
  async create(companyId: Long, dto?: AddCompanyStudyMediaDTO, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/study', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(dto)
      .execute();
  },
  /**
   * list
   */
  async list(companyId: Long, params?: ListCompanyStudyMediaParamsDTO, current?: number, pageSize?: number, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<ListCompanyStudyMediaItemDTO>>()
      .open('POST', '/company/{companyId}/study/list', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .addRequestParam('current', current)
      .addRequestParam('pageSize', pageSize)
      .execute();
  },
  /**
   * listCategory
   */
  async listCategory(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/company/{companyId}/study/category', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * play
   */
  async play(companyId: Long, mediaId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/study{mediaId}/play', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('mediaId', mediaId)
      .execute();
  },
  /**
   * remove
   */
  async remove(companyId: Long, mediaId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/study{mediaId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('mediaId', mediaId)
      .execute();
  },
  /**
   * transfer
   */
  async transfer(companyId: Long, mediaId: Long, targetCompanyId: Long[], settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/study/{mediaId}/transfer', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('mediaId', mediaId)
      .addRequestParam('targetCompanyId', targetCompanyId)
      .execute();
  },
  /**
   * updatePermission
   */
  async updatePermission(companyId: Long, category: string, departmentIds: Long[], settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/study/permission', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('category', category)
      .addRequestParam('departmentIds', departmentIds)
      .execute();
  },
};

/**
 * customerController
 * @iface com.weiyirong99.rms.api.controller.auth.CustomerController
 */
export const customerController = {
  /**
   * addAlarm
   */
  async addAlarm(companyId: Long, id: Long, alarmMinutes: number, message: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/customers/{id}/alarm', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .addRequestParam('alarmMinutes', alarmMinutes)
      .addRequestParam('message', message)
      .execute();
  },
  /**
   * addEvent
   */
  async addEvent(companyId: Long, id: Long, type: CustomerEventTypeEnum, comment: string, remark?: string, settings?: Partial<Settings>) {
    return new Runtime<CustomerEventDTO>()
      .open('POST', '/company/{companyId}/customers/{id}/events', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .addRequestParam('type', type)
      .addRequestParam('comment', comment)
      .addRequestParam('remark', remark)
      .execute();
  },
  /**
   * addEventV2
   */
  async addEventV2(companyId: Long, id: Long, request: AddCustomerEventRequest, settings?: Partial<Settings>) {
    return new Runtime<CustomerEventDTO>()
      .open('POST', '/company/{companyId}/customers/{id}/events_v2', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .addRequestBody(request)
      .execute();
  },
  /**
   * addLeaderEvent
   */
  async addLeaderEvent(companyId: Long, id: Long, comment: string, settings?: Partial<Settings>) {
    return new Runtime<CustomerEventDTO>()
      .open('POST', '/company/{companyId}/customers/{id}/leaderEvent', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .addRequestParam('comment', comment)
      .execute();
  },
  /**
   * callCustomer
   */
  async callCustomer(companyId: Long, id: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/customers/{id}/call', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .execute();
  },
  /**
   * createCustomer
   */
  async createCustomer(companyId: Long, params: AddCustomerDTO, settings?: Partial<Settings>) {
    return new Runtime<CustomerDTO>()
      .open('POST', '/company/{companyId}/customers', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .execute();
  },
  /**
   * dropToIdle
   */
  async dropToIdle(companyId: Long, id: Long, comment?: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/customers/{id}/drop_idle', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .addRequestParam('comment', comment)
      .execute();
  },
  /**
   * dropToIdleBatch
   */
  async dropToIdleBatch(companyId: Long, id: Long[], comment?: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/customers/drop_idle_batch', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('id', id)
      .addRequestParam('comment', comment)
      .execute();
  },
  /**
   * dropToPublic
   */
  async dropToPublic(companyId: Long, id: Long, comment?: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/customers/{id}/drop_public', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .addRequestParam('comment', comment)
      .execute();
  },
  /**
   * dropToPublicBatch
   */
  async dropToPublicBatch(companyId: Long, id: Long[], comment?: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/customers/drop_public_batch', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('id', id)
      .addRequestParam('comment', comment)
      .execute();
  },
  /**
   * getCustomerCallLogs
   */
  async getCustomerCallLogs(companyId: Long, customerId: Long, settings?: Partial<Settings>) {
    return new Runtime<CallLogDTO[]>()
      .open('GET', '/company/{companyId}/customers/{customerId}/call-logs', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('customerId', customerId)
      .execute();
  },
  /**
   * getDetail
   */
  async getDetail(companyId: Long, id: Long, settings?: Partial<Settings>) {
    return new Runtime<CustomerDTO>()
      .open('GET', '/company/{companyId}/customers/{id}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .execute();
  },
  /**
   * getDetailByMobile
   */
  async getDetailByMobile(companyId: Long, mobile: string, settings?: Partial<Settings>) {
    return new Runtime<CustomerDTO>()
      .open('GET', '/company/{companyId}/customer_by_mobile', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('mobile', mobile)
      .execute();
  },
  /**
   * listChannel
   */
  async listChannel(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/company/{companyId}/customers/channel', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listCustomer
   */
  async listCustomer(companyId: Long, params?: ListCustomerParamsDTO, listType?: ListCustomerType, group?: CustomerGroupEnum, current?: number, pageSize?: number, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<CustomerListItemDTO>>()
      .open('POST', '/company/{companyId}/customers/list', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .addRequestParam('listType', listType)
      .addRequestParam('group', group)
      .addRequestParam('current', current)
      .addRequestParam('pageSize', pageSize)
      .execute();
  },
  /**
   * listCustomerEvents
   */
  async listCustomerEvents(companyId: Long, page?: number, size?: number, params?: ListCustomerEventsParamsDTO, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<CustomerEventListItem>>()
      .open('POST', '/company/{companyId}/customer_events_list', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('page', page)
      .addRequestParam('size', size)
      .addRequestBody(params)
      .execute();
  },
  /**
   * listCustomerV2
   */
  async listCustomerV2(companyId: Long, params?: ListCustomerParamsDTO, listType?: ListCustomerType, group?: CustomerGroupEnum, current?: number, pageSize?: number, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<CustomerListItemV2DTO>>()
      .open('POST', '/company/{companyId}/customers/list_v2', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .addRequestParam('listType', listType)
      .addRequestParam('group', group)
      .addRequestParam('current', current)
      .addRequestParam('pageSize', pageSize)
      .execute();
  },
  /**
   * listEvent
   */
  async listEvent(companyId: Long, id: Long, settings?: Partial<Settings>) {
    return new Runtime<EventDTO[]>()
      .open('GET', '/company/{companyId}/customers/{id}/events', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .execute();
  },
  /**
   * listMobileCity
   */
  async listMobileCity(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/company/{companyId}/customers/mobile_city', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * pickCustomer
   */
  async pickCustomer(companyId: Long, customerIdList: Long[], settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/customers/pick', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(customerIdList)
      .execute();
  },
  /**
   * pickCustomerV2
   */
  async pickCustomerV2(companyId: Long, request: PickCustomerRequest, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/customers/pickV2', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .execute();
  },
  /**
   * queryMobileLocation
   */
  async queryMobileLocation(companyId: Long, id: Long, settings?: Partial<Settings>) {
    return new Runtime<MobileLocationDTO>()
      .open('GET', '/company/{companyId}/customers/{id}/mobile_location', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .execute();
  },
  /**
   * reAllocate
   */
  async reAllocate(companyId: Long, params: ReAllocateCustomerParams[], fromPool: CustomerPoolEnum, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/customers/reallocate', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .addRequestParam('fromPool', fromPool)
      .execute();
  },
  /**
   * reAllocateV2
   */
  async reAllocateV2(companyId: Long, params: ReAllocateCustomerV2Params[], fromPool: CustomerPoolEnum, group?: CustomerGroupEnum, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/customers/reallocateV2', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .addRequestParam('fromPool', fromPool)
      .addRequestParam('group', group)
      .execute();
  },
  /**
   * transfer
   */
  async transfer(companyId: Long, id: Long, targetUserId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/customers/{id}/transfer', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .addRequestParam('targetUserId', targetUserId)
      .execute();
  },
  /**
   * updateCustomer
   */
  async updateCustomer(companyId: Long, id: Long, dto: CustomerDTO, settings?: Partial<Settings>) {
    return new Runtime<CustomerDTO>()
      .open('PUT', '/company/{companyId}/customers/{id}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .addRequestBody(dto)
      .execute();
  },
  /**
   * updateScore
   */
  async updateScore(companyId: Long, id: Long, score: number, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/customers/{id}/score', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .addRequestParam('score', score)
      .execute();
  },
};

/**
 * dataAnalyzeController
 * @iface com.weiyirong99.rms.api.controller.auth.DataAnalyzeController
 */
export const dataAnalyzeController = {
  /**
   * channelAnalyze
   */
  async channelAnalyze(companyId: Long, request?: ChannelAnalyzeRequest, settings?: Partial<Settings>) {
    return new Runtime<ChannelAnalyzeDTO[]>()
      .open('POST', '/company/{companyId}/channel_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .execute();
  },
  /**
   * channelStarAnalyze
   */
  async channelStarAnalyze(companyId: Long, request: ChannelAnalyzeRequest | null, state: CustomerStateEnum, channel: string[], settings?: Partial<Settings>) {
    return new Runtime<BaseDataAnalyzeDTO>()
      .open('POST', '/company/{companyId}/channel_star_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .addRequestParam('state', state)
      .addRequestParam('channel', channel)
      .execute();
  },
  /**
   * customerAnalyze
   */
  async customerAnalyze(companyId: Long, start?: string, end?: string, settings?: Partial<Settings>) {
    return new Runtime<CustomerAnalyzeDTO[]>()
      .open('GET', '/company/{companyId}/customer_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('start', start)
      .addRequestParam('end', end)
      .execute();
  },
  /**
   * handleAnalyse
   */
  async handleAnalyse(companyId: Long, params: HandleAnalyseParams, settings?: Partial<Settings>) {
    return new Runtime<HandleAnalyseDTO[]>()
      .open('POST', '/company/{companyId}/handle_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .execute();
  },
  /**
   * homeTop
   */
  async homeTop(companyId: Long, all?: boolean, settings?: Partial<Settings>) {
    return new Runtime<HomeTopDTO[]>()
      .open('GET', '/company/{companyId}/home_top', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('all', all)
      .execute();
  },
  /**
   * listMonthlyData
   */
  async listMonthlyData(companyId: Long, departmentIds: Long[], settings?: Partial<Settings>) {
    return new Runtime<MonthlyDataDTO[]>()
      .open('GET', '/company/{companyId}/monthly_data', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('departmentIds', departmentIds)
      .execute();
  },
  /**
   * loanAnalyze
   */
  async loanAnalyze(companyId: Long, request: LoanAnalyzeRequest, settings?: Partial<Settings>) {
    return new Runtime<LoanAnalyzeDTO[]>()
      .open('POST', '/company/{companyId}/loan_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .execute();
  },
  /**
   * mobileTodayAnalyze
   */
  async mobileTodayAnalyze(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<MobileTodayAnalyzeDTO>()
      .open('GET', '/company/{companyId}/mobile_today_analyze', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * mobileTotalAnalyze
   */
  async mobileTotalAnalyze(companyId: Long, start?: string, end?: string, settings?: Partial<Settings>) {
    return new Runtime<MobileTotalAnalyzeDTO[]>()
      .open('GET', '/company/{companyId}/mobile_total_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('start', start)
      .addRequestParam('end', end)
      .execute();
  },
  /**
   * newDataAnalyze
   */
  async newDataAnalyze(companyId: Long, start: string, end: string, from?: CustomerFromEnum, settings?: Partial<Settings>) {
    return new Runtime<NewDataAnalyzeDTO[]>()
      .open('GET', '/company/{companyId}/new_data_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('start', start)
      .addRequestParam('end', end)
      .addRequestParam('from', from)
      .execute();
  },
  /**
   * newDataAnalyzeStar
   */
  async newDataAnalyzeStar(companyId: Long, start: string, end: string, from: CustomerFromEnum | null, userId: Long[], state: CustomerStateEnum, settings?: Partial<Settings>) {
    return new Runtime<BaseDataAnalyzeDTO>()
      .open('POST', '/company/{companyId}/new_data_analyze_star', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('start', start)
      .addRequestParam('end', end)
      .addRequestParam('from', from)
      .addRequestParam('userId', userId)
      .addRequestParam('state', state)
      .execute();
  },
  /**
   * newDataAnalyzeSummary
   */
  async newDataAnalyzeSummary(companyId: Long, depIds?: Long[], settings?: Partial<Settings>) {
    return new Runtime<HomeAnalyseDTO>()
      .open('GET', '/company/{companyId}/new_data_analyze_summary', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('depIds', depIds)
      .execute();
  },
  /**
   * summary
   */
  async summary(companyId: Long, departmentIds: Long[], settings?: Partial<Settings>) {
    return new Runtime<SummaryDTO>()
      .open('GET', '/company/{companyId}/summary', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('departmentIds', departmentIds)
      .execute();
  },
  /**
   * userCustomerStarQuery
   */
  async userCustomerStarQuery(companyId: Long, start: string, end: string, userIds: Long[], from: CustomerFromEnum | null, type: StarDetailQueryTypeEnum, settings?: Partial<Settings>) {
    return new Runtime<BaseDataAnalyzeDTO>()
      .open('POST', '/company/{companyId}/user_customer_star_query', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('start', start)
      .addRequestParam('end', end)
      .addRequestParam('userIds', userIds)
      .addRequestParam('from', from)
      .addRequestParam('type', type)
      .execute();
  },
  /**
   * welcomeCoreHeader
   */
  async welcomeCoreHeader(companyId: Long, departmentIds: Long[], settings?: Partial<Settings>) {
    return new Runtime<WelcomeCoreHeaderDataDTO>()
      .open('GET', '/company/{companyId}/welcome_core_header_data', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('departmentIds', departmentIds)
      .execute();
  },
};

/**
 * loanController
 * @iface com.weiyirong99.rms.api.controller.auth.LoanController
 */
export const loanController = {
  /**
   * add
   */
  async add(companyId: Long, addLoanDTO: AddLoanDTO, settings?: Partial<Settings>) {
    return new Runtime<Long>()
      .open('POST', '/company/{companyId}/loan/add', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(addLoanDTO)
      .execute();
  },
  /**
   * list
   */
  async list(companyId: Long, current?: number, pageSize?: number, params?: ListCustomerLoanParamsDTO, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<CustomerLoanDTO>>()
      .open('POST', '/company/{companyId}/loan', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('current', current)
      .addRequestParam('pageSize', pageSize)
      .addRequestBody(params)
      .execute();
  },
  /**
   * listBank
   */
  async listBank(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/company/{companyId}/loan/bank', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * remove
   */
  async remove(companyId: Long, id: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/loan/{id}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .execute();
  },
};

/**
 * oSSController
 * @iface com.weiyirong99.rms.api.controller.auth.OSSController
 */
export const oSSController = {
  /**
   * getOSSDirectUploadToken
   */
  async getOSSDirectUploadToken(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<OSSDirectSignature>()
      .open('GET', '/company/{companyId}/oss_direct_upload_token', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * getOSSMediaUploadToken
   */
  async getOSSMediaUploadToken(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<OSSDirectSignature>()
      .open('GET', '/company/{companyId}/oss_media_upload_token', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * getOSSUrl
   */
  async getOSSUrl(companyId: Long, path: string, expire?: Long, process?: string, settings?: Partial<Settings>) {
    return new Runtime<string>()
      .open('GET', '/company/{companyId}/oss_url', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('path', path)
      .addRequestParam('expire', expire)
      .addRequestParam('process', process)
      .execute();
  },
  /**
   * getOSSUrlBatch
   */
  async getOSSUrlBatch(companyId: Long, paths: string[], expire?: Long, process?: string, settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('POST', '/company/{companyId}/oss_url_batch', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('paths', paths)
      .addRequestParam('expire', expire)
      .addRequestParam('process', process)
      .execute();
  },
};

/**
 * outsideController
 * @iface com.weiyirong99.rms.api.controller.auth.OutsideController
 */
export const outsideController = {
  /**
   * clearAll
   */
  async clearAll(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/outside/clearAll', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * dropToPublic
   */
  async dropToPublic(companyId: Long, size: Long, channel: string, pool: CustomerPoolEnum, settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('POST', '/company/{companyId}/outside/dropToPublic', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('size', size)
      .addRequestParam('channel', channel)
      .addRequestParam('pool', pool)
      .execute();
  },
  /**
   * getTotal
   */
  async getTotal(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<Long>()
      .open('GET', '/company/{companyId}/outside/total', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * importOutside
   */
  async importOutside(companyId: Long, file: MultipartFile, state: CustomerStateEnum, star: number, settings?: Partial<Settings>) {
    return new Runtime<ImportOutsideResponse>()
      .open('POST', '/company/{companyId}/outside/import', settings)
      .addPathVariable('companyId', companyId)
      .addMultipartFile('file', file)
      .addRequestParam('state', state)
      .addRequestParam('star', star)
      .execute();
  },
  /**
   * list
   */
  async list(companyId: Long, current?: number, pageSize?: number, params?: ListOutsideParamsDTO, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<OutsideItemDTO>>()
      .open('POST', '/company/{companyId}/outside', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('current', current)
      .addRequestParam('pageSize', pageSize)
      .addRequestBody(params)
      .execute();
  },
  /**
   * reAllocate
   */
  async reAllocate(companyId: Long, params: OutsideAllocateParamsDTO, settings?: Partial<Settings>) {
    return new Runtime<Long[]>()
      .open('POST', '/company/{companyId}/outside/reAllocate', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .execute();
  },
  /**
   * remove
   */
  async remove(companyId: Long, id: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/outside/{id}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .execute();
  },
};

/**
 * roleController
 * @iface com.weiyirong99.rms.api.controller.auth.RoleController
 */
export const roleController = {
  /**
   * add
   */
  async add(companyId: Long, addRoleRequest: AddRoleRequest, settings?: Partial<Settings>) {
    return new Runtime<RoleDTO>()
      .open('POST', '/company/{companyId}/role', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(addRoleRequest)
      .execute();
  },
  /**
   * list
   */
  async list(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<RoleDTO[]>()
      .open('GET', '/company/{companyId}/role', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listAll
   */
  async listAll(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<RoleDTO[]>()
      .open('GET', '/company/{companyId}/role/all', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listPermissions
   */
  async listPermissions(companyId: string, roleId: Long, settings?: Partial<Settings>) {
    return new Runtime<RolePermissionDTO[]>()
      .open('GET', '/company/{companyId}/role/{roleId}/permission', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('roleId', roleId)
      .execute();
  },
  /**
   * update
   */
  async update(companyId: Long, roleId: Long, addRoleRequest: AddRoleRequest, settings?: Partial<Settings>) {
    return new Runtime<RoleDTO>()
      .open('PUT', '/company/{companyId}/role/{roleId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('roleId', roleId)
      .addRequestBody(addRoleRequest)
      .execute();
  },
  /**
   * updatePermissions
   */
  async updatePermissions(companyId: Long, roleId: Long, codes: string[], settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/role/{roleId}/permission', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('roleId', roleId)
      .addRequestBody(codes)
      .execute();
  },
};

/**
 * smsController
 * @iface com.weiyirong99.rms.api.controller.auth.SmsController
 */
export const smsController = {
  /**
   * getBalance
   */
  async getBalance(companyId?: Long, settings?: Partial<Settings>) {
    return new Runtime<SmsBalanceResponse>()
      .open('GET', '/system/sms/balance', settings)
      .addRequestParam('companyId', companyId)
      .execute();
  },
  /**
   * getConfig
   */
  async getConfig(companyId?: Long, settings?: Partial<Settings>) {
    return new Runtime<SmsConfig>()
      .open('GET', '/system/sms/config', settings)
      .addRequestParam('companyId', companyId)
      .execute();
  },
  /**
   * sendByFilter
   */
  async sendByFilter(request: SmsSendByFilterRequest, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/sms/send-by-filter', settings)
      .addRequestBody(request)
      .execute();
  },
  /**
   * sendByIds
   */
  async sendByIds(request: SmsSendByIdsRequest, settings?: Partial<Settings>) {
    return new Runtime<SmsSendResponse>()
      .open('POST', '/system/sms/send-by-ids', settings)
      .addRequestBody(request)
      .execute();
  },
  /**
   * updateConfig
   */
  async updateConfig(companyId: Long | null, config: SmsConfig, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/system/sms/config', settings)
      .addRequestParam('companyId', companyId)
      .addRequestBody(config)
      .execute();
  },
};

/**
 * systemController
 * @iface com.weiyirong99.rms.api.controller.auth.SystemController
 */
export const systemController = {
  /**
   * cleanDeletedCustomerEvent
   */
  async cleanDeletedCustomerEvent(settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/clean_deleted_customer_event', settings)
      .execute();
  },
  /**
   * cleanInValidEvent
   */
  async cleanInValidEvent(keyword?: string[], settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/clean_invalid_event', settings)
      .addRequestParam('keyword', keyword)
      .execute();
  },
  /**
   * cleanSomeCustomer
   */
  async cleanSomeCustomer(comments: string[], limit: Long, settings?: Partial<Settings>) {
    return new Runtime<boolean>()
      .open('POST', '/system/clean_some_customer_by_last_event', settings)
      .addRequestParam('comments', comments)
      .addRequestParam('limit', limit)
      .execute();
  },
  /**
   * clearCustomerAndEvent
   */
  async clearCustomerAndEvent(settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/clear_customer_and_event', settings)
      .execute();
  },
  /**
   * fixHandledAt
   */
  async fixHandledAt(settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/fix_handled_at', settings)
      .execute();
  },
  /**
   * generateCompanyLoginToken
   */
  async generateCompanyLoginToken(id: Long, settings?: Partial<Settings>) {
    return new Runtime<CompanyLoginTokenResponse>()
      .open('POST', '/system/generate_company_login_token', settings)
      .addRequestParam('id', id)
      .execute();
  },
  /**
   * generateMobileHash
   */
  async generateMobileHash(companyId?: Long[], star?: number[], channel?: string[], settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/system/generate_mobile_hash', settings)
      .addRequestParam('companyId', companyId)
      .addRequestParam('star', star)
      .addRequestParam('channel', channel)
      .execute();
  },
  /**
   * getAutoDropToBlackListConfig
   */
  async getAutoDropToBlackListConfig(settings?: Partial<Settings>) {
    return new Runtime<AutoDropToBlackListConfig>()
      .open('GET', '/system/auto_drop_to_blacklist_config', settings)
      .execute();
  },
  /**
   * getCustomerAiProfileConfig
   */
  async getCustomerAiProfileConfig(settings?: Partial<Settings>) {
    return new Runtime<CustomerAiProfileConfig>()
      .open('GET', '/system/customer_ai_profile_config', settings)
      .execute();
  },
  /**
   * getCustomerAiProfileTask
   */
  async getCustomerAiProfileTask(companyId: Long, mobile: string, settings?: Partial<Settings>) {
    return new Runtime<CustomerAiProfileTaskEntity>()
      .open('GET', '/system/customer_ai_profile_task', settings)
      .addRequestParam('companyId', companyId)
      .addRequestParam('mobile', mobile)
      .execute();
  },
  /**
   * getCustomerAiProfileTaskProgress
   */
  async getCustomerAiProfileTaskProgress(settings?: Partial<Settings>) {
    return new Runtime<CustomerAiProfileTaskService>()
      .open('GET', '/system/customer_ai_profile_task_progress', settings)
      .execute();
  },
  /**
   * getInvalidCustomerEventComment
   */
  async getInvalidCustomerEventComment(settings?: Partial<Settings>) {
    return new Runtime<InvalidCustomerEventDTO>()
      .open('GET', '/system/invalid_customer_event_comment', settings)
      .execute();
  },
  /**
   * handleInvalidCustomer
   */
  async handleInvalidCustomer(settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/handle_invalid_customer', settings)
      .execute();
  },
  /**
   * listCompany
   */
  async listCompany(settings?: Partial<Settings>) {
    return new Runtime<CompanyDTO[]>()
      .open('GET', '/system/company/list', settings)
      .execute();
  },
  /**
   * runOneCustomerAiProfile
   */
  async runOneCustomerAiProfile(companyId: Long, mobile: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/customer_ai_profile_run_one', settings)
      .addRequestParam('companyId', companyId)
      .addRequestParam('mobile', mobile)
      .execute();
  },
  /**
   * splitCompany
   */
  async splitCompany(settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/split_company', settings)
      .execute();
  },
  /**
   * updateAutoDropToBlackListConfig
   */
  async updateAutoDropToBlackListConfig(dto: AutoDropToBlackListConfig, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/auto_drop_to_blacklist_config', settings)
      .addRequestBody(dto)
      .execute();
  },
  /**
   * updateCustomerAiProfileConfig
   */
  async updateCustomerAiProfileConfig(dto: CustomerAiProfileConfig, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/customer_ai_profile_config', settings)
      .addRequestBody(dto)
      .execute();
  },
  /**
   * updateInvalidCustomerEventComment
   */
  async updateInvalidCustomerEventComment(dto: InvalidCustomerEventDTO, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/invalid_customer_event_comment', settings)
      .addRequestBody(dto)
      .execute();
  },
};

/**
 * userCallController
 * @iface com.weiyirong99.rms.api.controller.auth.UserCallController
 */
export const userCallController = {
  /**
   * add
   */
  async add(companyId: Long, mobile: string, duration: number | null, createdAt: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/user-call', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('mobile', mobile)
      .addRequestParam('duration', duration)
      .addRequestParam('createdAt', createdAt)
      .execute();
  },
  /**
   * addCallLog
   */
  async addCallLog(companyId: Long, params: AddCallLogParamsDTO[], settings?: Partial<Settings>) {
    return new Runtime<Long>()
      .open('POST', '/company/{companyId}/user-call-log', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .execute();
  },
  /**
   * addSmsLog
   */
  async addSmsLog(companyId: Long, params: AddSmsParamsDTO[], settings?: Partial<Settings>) {
    return new Runtime<Long>()
      .open('POST', '/company/{companyId}/user-sms-log', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .execute();
  },
};

/**
 * userController
 * @iface com.weiyirong99.rms.api.controller.auth.UserController
 */
export const userController = {
  /**
   * addUser
   */
  async addUser(companyId: Long, addUserRequest: AddUserRequest, settings?: Partial<Settings>) {
    return new Runtime<UserDTO>()
      .open('POST', '/company/{companyId}/user', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(addUserRequest)
      .execute();
  },
  /**
   * countAllUserNewCustomerLimit
   */
  async countAllUserNewCustomerLimit(companyId: Long, depId?: Long, settings?: Partial<Settings>) {
    return new Runtime<number>()
      .open('GET', '/company/{companyId}/user/total_limit', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('depId', depId)
      .execute();
  },
  /**
   * countAllUserNewCustomerLimitV2
   */
  async countAllUserNewCustomerLimitV2(companyId: Long, params: ListUserV2Params, settings?: Partial<Settings>) {
    return new Runtime<UserCountAllNewCustomerLimitResponse>()
      .open('POST', '/company/{companyId}/user/total_limit_v2', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .execute();
  },
  /**
   * get
   */
  async get(companyId: Long, userId: Long, settings?: Partial<Settings>) {
    return new Runtime<GetUserInfoDTO>()
      .open('GET', '/company/{companyId}/user/{userId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .execute();
  },
  /**
   * getUserConfig
   */
  async getUserConfig(companyId: Long, userId: Long, settings?: Partial<Settings>) {
    return new Runtime<UserConfigDTO>()
      .open('GET', '/company/{companyId}/user/{userId}/config', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .execute();
  },
  /**
   * listAllBaseUser
   */
  async listAllBaseUser(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<BaseUserDTO[]>()
      .open('GET', '/company/{companyId}/user/all_base', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listAllUser
   */
  async listAllUser(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<BaseUserDTO[]>()
      .open('GET', '/company/{companyId}/user/all', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listLatest
   */
  async listLatest(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<UserMessageListItemDTO[]>()
      .open('GET', '/company/{companyId}/user/message/latest', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listMessage
   */
  async listMessage(companyId: Long, current?: number, pageSize?: number, isRead?: boolean, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<UserMessageListItemDTO>>()
      .open('GET', '/company/{companyId}/user/message', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('current', current)
      .addRequestParam('pageSize', pageSize)
      .addRequestParam('isRead', isRead)
      .execute();
  },
  /**
   * listOnline
   */
  async listOnline(companyId: Long, type: string, settings?: Partial<Settings>) {
    return new Runtime<Long[]>()
      .open('GET', '/company/{companyId}/user/online', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('type', type)
      .execute();
  },
  /**
   * listUser
   */
  async listUser(companyId: Long, current: number | null, pageSize: number | null, params: ListUserV2Params, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<ListUserItemDTO>>()
      .open('POST', '/company/{companyId}/user/list', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('current', current)
      .addRequestParam('pageSize', pageSize)
      .addRequestBody(params)
      .execute();
  },
  /**
   * listUserV3
   */
  async listUserV3(companyId: Long, params: ListUserV3Params, settings?: Partial<Settings>) {
    return new Runtime<ListUserItemV3DTO[]>()
      .open('POST', '/company/{companyId}/user/list_v3', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .execute();
  },
  /**
   * readMessage
   */
  async readMessage(companyId: Long, messageId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/user/message/{messageId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('messageId', messageId)
      .execute();
  },
  /**
   * resetPassword
   */
  async resetPassword(companyId: Long, userId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/user/{userId}/restPassword', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .execute();
  },
  /**
   * switchUser
   */
  async switchUser(companyId: Long, userId: Long, ip?: string, settings?: Partial<Settings>) {
    return new Runtime<SwitchUserResponse>()
      .open('POST', '/company/{companyId}/user/{userId}/switch', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .addRequestParam('ip', ip)
      .execute();
  },
  /**
   * switchVacation
   */
  async switchVacation(companyId: Long, userId: Long, isVacation: boolean, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/user/{userId}/switch_vacation', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .addRequestParam('isVacation', isVacation)
      .execute();
  },
  /**
   * transfer
   */
  async transfer(companyId: Long, userId: Long, depId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/user/{userId}/transfer', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .addRequestParam('depId', depId)
      .execute();
  },
  /**
   * unbindUserDevice
   */
  async unbindUserDevice(companyId: Long, userId: Long, deviceId: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/user/{userId}/device/{deviceId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .addPathVariable('deviceId', deviceId)
      .execute();
  },
  /**
   * updateAvatar
   */
  async updateAvatar(companyId: Long, userId: Long, avatar: MultipartFile, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/user/{userId}/avatar', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .addMultipartFile('avatar', avatar)
      .execute();
  },
  /**
   * updateIdCard
   */
  async updateIdCard(companyId: Long, userId: Long, frontend: MultipartFile, backend: MultipartFile, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/user/{userId}/id_card', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .addMultipartFile('frontend', frontend)
      .addMultipartFile('backend', backend)
      .execute();
  },
  /**
   * updatePassword
   */
  async updatePassword(companyId: Long, oldPassword: string, newPassword: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/user/password', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('oldPassword', oldPassword)
      .addRequestParam('newPassword', newPassword)
      .execute();
  },
  /**
   * updateUser
   */
  async updateUser(companyId: Long, userId: Long, updateUserRequest: AddUserRequest, settings?: Partial<Settings>) {
    return new Runtime<UserDTO>()
      .open('PUT', '/company/{companyId}/user/{userId}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .addRequestBody(updateUserRequest)
      .execute();
  },
  /**
   * updateUserConfig
   */
  async updateUserConfig(companyId: Long, userId: Long, updateUserConfigDTO: UpdateUserConfigDTO, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('PUT', '/company/{companyId}/user/{userId}/config', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('userId', userId)
      .addRequestBody(updateUserConfigDTO)
      .execute();
  },
};

/**
 * userFeedbackController
 * @iface com.weiyirong99.rms.api.controller.auth.UserFeedbackController
 */
export const userFeedbackController = {
  /**
   * create
   */
  async create(companyId: Long, body: string, anon: boolean, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/user_feedback', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('body', body)
      .addRequestParam('anon', anon)
      .execute();
  },
  /**
   * get
   */
  async get(companyId: Long, id: Long, settings?: Partial<Settings>) {
    return new Runtime<UserFeedbackListItemDTO>()
      .open('GET', '/company/{companyId}/user_feedback/{id}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .execute();
  },
  /**
   * list
   */
  async list(companyId: Long, page?: number, pageSize?: number, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<UserFeedbackListItemDTO>>()
      .open('GET', '/company/{companyId}/user_feedback', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('page', page)
      .addRequestParam('pageSize', pageSize)
      .execute();
  },
};

/**
 * utilsController
 * @iface com.weiyirong99.rms.api.controller.auth.UtilsController
 */
export const utilsController = {
  /**
   * updateLastEventId
   */
  async updateLastEventId(settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/utils/updateLastEventId', settings)
      .execute();
  },
  /**
   * updateTrace
   */
  async updateTrace(settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/utils/updateTrace', settings)
      .execute();
  },
};

/**
 * visitorController
 * @iface com.weiyirong99.rms.api.controller.auth.VisitorController
 */
export const visitorController = {
  /**
   * add
   */
  async add(companyId: Long, name: string, mobile: string, agentName: string | null, agentMobile: string | null, star: number, isSign: boolean, point?: number, amount?: number, contractId?: string, qualification?: string, liability?: string, remark?: string, contractImg?: MultipartFile, signImg?: MultipartFile, settings?: Partial<Settings>) {
    return new Runtime<Long>()
      .open('POST', '/company/{companyId}/visitor/add', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('name', name)
      .addRequestParam('mobile', mobile)
      .addRequestParam('agentName', agentName)
      .addRequestParam('agentMobile', agentMobile)
      .addRequestParam('star', star)
      .addRequestParam('isSign', isSign)
      .addRequestParam('point', point)
      .addRequestParam('amount', amount)
      .addRequestParam('contractId', contractId)
      .addRequestParam('qualification', qualification)
      .addRequestParam('liability', liability)
      .addRequestParam('remark', remark)
      .addMultipartFile('contractImg', contractImg)
      .addMultipartFile('signImg', signImg)
      .execute();
  },
  /**
   * checkMobile
   */
  async checkMobile(companyId: Long, mobile: string, settings?: Partial<Settings>) {
    return new Runtime<boolean>()
      .open('POST', '/company/{companyId}/visitor_mobile_check', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('mobile', mobile)
      .execute();
  },
  /**
   * getData
   */
  async getData(companyId: Long, start: string, end: string, departmentId?: Long, settings?: Partial<Settings>) {
    return new Runtime<VisitorListItemDTO[]>()
      .open('GET', '/company/{companyId}/visitor/data', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('start', start)
      .addRequestParam('end', end)
      .addRequestParam('departmentId', departmentId)
      .execute();
  },
  /**
   * list
   */
  async list(companyId: Long, current?: number, pageSize?: number, params?: ListVisitorParamsDTO, settings?: Partial<Settings>) {
    return new Runtime<PageResponse<VisitorListItemDTO>>()
      .open('POST', '/company/{companyId}/visitor', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('current', current)
      .addRequestParam('pageSize', pageSize)
      .addRequestBody(params)
      .execute();
  },
  /**
   * remove
   */
  async remove(companyId: Long, id: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('DELETE', '/company/{companyId}/visitor/{id}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .execute();
  },
  /**
   * update
   */
  async update(companyId: Long, id: Long, dto: UpdateVisitorParamsDTO, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/company/{companyId}/visitor/update/{id}', settings)
      .addPathVariable('companyId', companyId)
      .addPathVariable('id', id)
      .addRequestBody(dto)
      .execute();
  },
};

/**
 * openAPIController
 * @iface com.weiyirong99.rms.api.controller.openapi.OpenAPIController
 */
export const openAPIController = {
  /**
   * allCustomerMobile
   */
  async allCustomerMobile(companyId: Long, star?: number[], settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/openapi/{companyId}/all_customer_mobile', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('star', star)
      .execute();
  },
  /**
   * channelAnalyze
   */
  async channelAnalyze(companyId: Long, request?: ChannelAnalyzeRequest, settings?: Partial<Settings>) {
    return new Runtime<ChannelAnalyzeDTO[]>()
      .open('POST', '/openapi/{companyId}/channel_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .execute();
  },
  /**
   * channelStarAnalyze
   */
  async channelStarAnalyze(companyId: Long, request: ChannelAnalyzeRequest | null, state: CustomerStateEnum, channel: string[], settings?: Partial<Settings>) {
    return new Runtime<BaseDataAnalyzeDTO>()
      .open('POST', '/openapi/{companyId}/channel_star_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .addRequestParam('state', state)
      .addRequestParam('channel', channel)
      .execute();
  },
  /**
   * createCustomer
   */
  async createCustomer(companyId: Long, request: CreateCustomerRequest, settings?: Partial<Settings>) {
    return new Runtime<OpenAPICreateCustomerResponse>()
      .open('POST', '/openapi/{companyId}/customer', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .execute();
  },
  /**
   * generateMobileHash
   */
  async generateMobileHash(star?: number[], settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/openapi/{companyId}/generate_mobile_hash', settings)
      .addRequestParam('star', star)
      .execute();
  },
  /**
   * generateMobileHashV2
   */
  async generateMobileHashV2(companyId: Long, star?: number[], settings?: Partial<Settings>) {
    return new Runtime<string[][]>()
      .open('GET', '/openapi/{companyId}/generate_mobile_hash_v2', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('star', star)
      .execute();
  },
  /**
   * getBlackList
   */
  async getBlackList(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/openapi/{companyId}/black_list', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * getCustomerBasicInfoByMobiles
   */
  async getCustomerBasicInfoByMobiles(companyId: Long, mobileList: string[], settings?: Partial<Settings>) {
    return new Runtime<OpenAPICustomerBasicModel[]>()
      .open('GET', '/openapi/{companyId}/customer_basic_info', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('mobileList', mobileList)
      .execute();
  },
  /**
   * getCustomerInfoByMobile
   */
  async getCustomerInfoByMobile(companyId: Long, mobile: string, md5?: boolean, settings?: Partial<Settings>) {
    return new Runtime<CustomerDTO>()
      .open('GET', '/openapi/{companyId}/get_customer_info_by_mobile', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('mobile', mobile)
      .addRequestParam('md5', md5)
      .execute();
  },
  /**
   * getSyncAllMobiles
   */
  async getSyncAllMobiles(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/openapi/{companyId}/sync/all_mobiles', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * getSyncCustomerEvents
   */
  async getSyncCustomerEvents(companyId: Long, request: SyncCustomersRequest, settings?: Partial<Settings>) {
    return new Runtime<OpenAPICustomerEvenDTO[]>()
      .open('POST', '/openapi/{companyId}/sync/customer_events', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .execute();
  },
  /**
   * getSyncCustomers
   */
  async getSyncCustomers(companyId: Long, request: SyncCustomersRequest, settings?: Partial<Settings>) {
    return new Runtime<CustomerDTO[]>()
      .open('POST', '/openapi/{companyId}/sync/customers', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .execute();
  },
  /**
   * getSyncStatus
   */
  async getSyncStatus(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<OpenAPISyncStatusResponse>()
      .open('POST', '/openapi/{companyId}/sync/status', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * handleAnalyse
   */
  async handleAnalyse(companyId: Long, params: HandleAnalyseParams, settings?: Partial<Settings>) {
    return new Runtime<HandleAnalyseDTO[]>()
      .open('POST', '/openapi/{companyId}/handle_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(params)
      .execute();
  },
  /**
   * homeTop
   */
  async homeTop(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<HomeTopDTO[]>()
      .open('GET', '/openapi/{companyId}/home_top', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * isCustomerExist
   */
  async isCustomerExist(companyId: Long, mobile: string, channel?: string, settings?: Partial<Settings>) {
    return new Runtime<boolean>()
      .open('GET', '/openapi/{companyId}/customer_exist', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('mobile', mobile)
      .addRequestParam('channel', channel)
      .execute();
  },
  /**
   * listAllChannels
   */
  async listAllChannels(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<string[]>()
      .open('GET', '/openapi/{companyId}/all_channels', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listAllCustomer
   */
  async listAllCustomer(companyId: Long, withName?: boolean, settings?: Partial<Settings>) {
    return new Runtime<string>()
      .open('GET', '/openapi/{companyId}/all_customers', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('withName', withName)
      .execute();
  },
  /**
   * listCustomerByMobile
   */
  async listCustomerByMobile(companyId: Long, mobileList: string[], settings?: Partial<Settings>) {
    return new Runtime<OpenapiCustomerDTO[]>()
      .open('GET', '/openapi/{companyId}/list', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('mobileList', mobileList)
      .execute();
  },
  /**
   * listDepartment
   */
  async listDepartment(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<BaseDepartmentDTO[]>()
      .open('GET', '/openapi/{companyId}/departments', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * listUser
   */
  async listUser(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<RMSUserDTO[]>()
      .open('GET', '/openapi/{companyId}/users', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * mqttAuth
   */
  async mqttAuth(companyId: string, request: MQTTAuthRequest, settings?: Partial<Settings>) {
    return new Runtime<MQTTAuthResponse>()
      .open('POST', '/openapi/{companyId}/mqtt_auth', settings)
      .addPathVariable('companyId', companyId)
      .addRequestBody(request)
      .execute();
  },
  /**
   * mqttOffline
   */
  async mqttOffline(companyId: Long, username: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/openapi/{companyId}/mqtt_offline', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('username', username)
      .execute();
  },
  /**
   * mqttOnline
   */
  async mqttOnline(companyId: Long, username: string, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/openapi/{companyId}/mqtt_online', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('username', username)
      .execute();
  },
  /**
   * newDataAnalyze
   */
  async newDataAnalyze(companyId: Long, start: string, end: string, from?: CustomerFromEnum, settings?: Partial<Settings>) {
    return new Runtime<NewDataAnalyzeDTO[]>()
      .open('GET', '/openapi/{companyId}/new_data_analyze', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('start', start)
      .addRequestParam('end', end)
      .addRequestParam('from', from)
      .execute();
  },
  /**
   * resetSyncCustomers
   */
  async resetSyncCustomers(companyId: Long, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/openapi/{companyId}/sync/reset', settings)
      .addPathVariable('companyId', companyId)
      .execute();
  },
  /**
   * userCustomerStarQuery
   */
  async userCustomerStarQuery(companyId: Long, start: string, end: string, userIds: Long[], from: CustomerFromEnum | null, type: StarDetailQueryTypeEnum, settings?: Partial<Settings>) {
    return new Runtime<BaseDataAnalyzeDTO>()
      .open('POST', '/openapi/{companyId}/user_customer_star_query', settings)
      .addPathVariable('companyId', companyId)
      .addRequestParam('start', start)
      .addRequestParam('end', end)
      .addRequestParam('userIds', userIds)
      .addRequestParam('from', from)
      .addRequestParam('type', type)
      .execute();
  },
};

/**
 * openApiWebMvcResource
 * @iface org.springdoc.webmvc.api.OpenApiWebMvcResource
 */
export const openApiWebMvcResource = {
  /**
   * openapiJson
   */
  async openapiJson(request?: any, apiDocsUrl?: string, locale?: any, settings?: Partial<Settings>) {
    return new Runtime<string>()
      .open('GET', '/v3/api-docs', settings)
      .addModelAttribute(request)
      .addRequestParam('apiDocsUrl', apiDocsUrl)
      .addRequestParam('locale', locale)
      .execute();
  },
  /**
   * openapiYaml
   */
  async openapiYaml(request?: any, apiDocsUrl?: string, locale?: any, settings?: Partial<Settings>) {
    return new Runtime<string>()
      .open('GET', '/v3/api-docs.yaml', settings)
      .addModelAttribute(request)
      .addRequestParam('apiDocsUrl', apiDocsUrl)
      .addRequestParam('locale', locale)
      .execute();
  },
};

/**
 * swaggerConfigResource
 * @iface org.springdoc.webmvc.ui.SwaggerConfigResource
 */
export const swaggerConfigResource = {
  /**
   * openapiJson
   */
  async openapiJson(request?: any, settings?: Partial<Settings>) {
    return new Runtime<Record<string, any>>()
      .open('GET', '/v3/api-docs/swagger-config', settings)
      .addModelAttribute(request)
      .execute();
  },
};

/**
 * swaggerWelcomeWebMvc
 * @iface org.springdoc.webmvc.ui.SwaggerWelcomeWebMvc
 */
export const swaggerWelcomeWebMvc = {
  /**
   * redirectToUi
   */
  async redirectToUi(request?: any, settings?: Partial<Settings>) {
    return new Runtime<any>()
      .open('GET', '/swagger-ui.html', settings)
      .addModelAttribute(request)
      .execute();
  },
};

/**
 * AppDownloadURLConfig
 * @iface com.weiyirong99.rms.api.model.config.AppDownloadURLConfig
 */
export interface AppDownloadURLConfig {
  apkName?: string;
  banOldMobileLogin?: boolean;
  banUnRootLogin?: boolean;
  downloadUrl?: string;
  lockDevice?: boolean;
  shouldUpdateAppByOldVersion?: boolean;
  version?: string;
}

/**
 * SystemConfigModel
 * @iface com.weiyirong99.rms.api.model.response.SystemConfigModel
 */
export interface SystemConfigModel {
  applicationType?: ApplicationTypeEnum;
  currentIP?: string;
  customerFroms?: CustomerFromEnum[];
  customerGroups?: CustomerGroupEnum[];
  customerStates?: CustomerStateEnum[];
  permissions?: PermissionCodeModel[];
}

/**
 * PermissionCodeModel
 * @iface com.weiyirong99.rms.api.model.response.PermissionCodeModel
 */
export interface PermissionCodeModel {
  code: string;
  description?: string;
  name: string;
  parentCode?: string;
  type: PermissionTypeEnum;
}

/**
 * SystemConfigV2Model
 * @iface com.weiyirong99.rms.api.model.response.SystemConfigV2Model
 */
export interface SystemConfigV2Model {
  callAndMsgUploadIntervalSeconds?: number;
  chatroomCollector?: string[];
  contactCollector?: string[];
  customerEventTypes?: Record<CustomerEventTypeEnum, string>;
  customerGroups?: Record<CustomerGroupEnum, string>;
  customerStates?: Record<CustomerStateEnum, string>;
  displayGroups?: CustomerGroupEnum[];
  maskMobileNumber?: boolean;
  messageCollector?: string[];
  quickComments?: string[];
  userCollector?: number[];
  wechatAvatarUploadIntervalSeconds?: number;
  wechatChatroomUploadIntervalSeconds?: number;
  wechatContactUploadIntervalSeconds?: number;
  wechatFileUploadIntervalSeconds?: number;
  wechatMessageUploadIntervalSeconds?: number;
  wechatUpgrade?: boolean;
  wechatUploadIntervalSeconds?: number;
  wechatUserUploadIntervalSeconds?: number;
}

/**
 * CurrentUserDTO
 * @iface com.weiyirong99.rms.api.service.dto.CurrentUserDTO
 */
export interface CurrentUserDTO extends UserDTO {
  userConfig?: UserConfigDTO;
}

/**
 * UserDTO
 * @iface com.weiyirong99.rms.api.service.dto.UserDTO
 */
export interface UserDTO extends BaseDTO {
  companyId?: Long;
  departmentId?: Long;
  isSuperAdmin: boolean;
  mobile: string;
  name: string;
  role?: RoleDTO;
  state: UserStateEnum;
}

/**
 * BaseDTO
 * @iface com.weiyirong99.rms.api.service.dto.BaseDTO
 */
export interface BaseDTO {
  createdAt: string;
  id: Long;
  updatedAt: string;
}

/**
 * RoleDTO
 * @iface com.weiyirong99.rms.api.service.dto.RoleDTO
 */
export interface RoleDTO extends BaseDTO {
  companyId?: Long;
  description?: string;
  name: string;
  permissions?: RolePermissionDTO[];
  views?: RoleViewDTO[];
}

/**
 * RolePermissionDTO
 * @iface com.weiyirong99.rms.api.service.dto.RolePermissionDTO
 */
export interface RolePermissionDTO extends BaseDTO {
  code: string;
  role: RoleDTO;
}

/**
 * RoleViewDTO
 * @iface com.weiyirong99.rms.api.service.dto.RoleViewDTO
 */
export interface RoleViewDTO extends BaseDTO {
  role: RoleDTO;
  view: RoleDTO;
}

/**
 * UserConfigDTO
 * @iface com.weiyirong99.rms.api.service.dto.UserConfigDTO
 */
export interface UserConfigDTO extends BaseDTO {
  appRegisterId?: string;
  avatar?: boolean;
  idCard?: boolean;
  loginWithoutSMS?: boolean;
  newCustomerLimit?: number;
  newCustomerStatus?: boolean;
  passwordLastUpdatedAt?: string;
  selfPause?: boolean;
  userId: Long;
}

/**
 * LoginResponse
 * @iface com.weiyirong99.rms.api.model.response.LoginResponse
 */
export interface LoginResponse {
  appDownloadUrl?: string;
  companyLogoUrl?: string;
  companyName?: string;
  mqttClientId?: string;
  mqttTopic?: string;
  systemMqttClientId?: string;
  systemMqttTopic?: string;
  token: string;
  uploadToken?: string;
  user: UserDTO;
}

/**
 * AppLoginRequest
 * @iface com.weiyirong99.rms.api.model.request.AppLoginRequest
 */
export interface AppLoginRequest {
  appVersion?: string;
  mobile: string;
  mobileMode?: string;
  mobileVersion?: string;
  password: string;
  registerId: string;
  rooted?: boolean;
}

/**
 * AuditAddFileRequest
 * @iface com.weiyirong99.rms.api.model.request.audit.AuditAddFileRequest
 */
export interface AuditAddFileRequest {
  md5: string;
  ossKey: string;
  type: AuditFileTypeEnum;
}

/**
 * AddCallLogParamsV2DTO
 * @iface com.weiyirong99.rms.api.service.dto.AddCallLogParamsV2DTO
 */
export interface AddCallLogParamsV2DTO {
  calledAt?: Long;
  duration?: number;
  id?: Long;
  mobile?: string;
  type: number;
}

/**
 * AddSmsParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.AddSmsParamsDTO
 */
export interface AddSmsParamsDTO {
  address?: string;
  body?: string;
  id?: Long;
  smsedAt?: Long;
  type?: number;
}

/**
 * AuditSystemInfoRequest
 * @iface com.weiyirong99.rms.api.model.request.audit.AuditSystemInfoRequest
 */
export interface AuditSystemInfoRequest {
  battery?: number;
  bootedAt?: Long;
  registerId?: string;
  location?: AuditSystemInfoRequest$1;
  network?: string;
  packages?: AuditSystemInfoRequest$2[];
  permissions?: Record<string, number>;
  rooted?: boolean;
  ssid?: string;
  systemVersion?: string;
  wechatStatus?: Record<string, number>;
  wechatVersion?: string[];
}

/**
 * AuditSystemInfoRequest$1
 * @iface com.weiyirong99.rms.api.model.request.audit.AuditSystemInfoRequest$Location
 */
export interface AuditSystemInfoRequest$1 {
  latitude?: number;
  longitude?: number;
}

/**
 * AuditSystemInfoRequest$2
 * @iface com.weiyirong99.rms.api.model.request.audit.AuditSystemInfoRequest$PackageInfo
 */
export interface AuditSystemInfoRequest$2 {
  appId?: string;
  appName?: string;
  createdAt?: Long;
  updatedAt?: Long;
}

/**
 * UserCallFileRequestDTO
 * @iface com.weiyirong99.rms.api.service.dto.UserCallFileRequestDTO
 */
export interface UserCallFileRequestDTO {
  dateAdded: Long;
  duration: Long;
  target: string;
  uploadMeta: OssSignedUrlResponse;
}

/**
 * OssSignedUrlResponse
 * @iface com.weiyirong99.rms.api.model.response.OssSignedUrlResponse$Meta
 */
export interface OssSignedUrlResponse {
  date?: string;
  filename?: string;
  request?: OssSignedRequest;
}

/**
 * OssSignedRequest
 * @iface com.weiyirong99.rms.api.model.request.OssSignedRequest
 */
export interface OssSignedRequest {
  fileFrom?: OssFileFromEnum;
  fileName?: string;
  type?: OssFileTypeEnum;
}

/**
 * AuditAddWechatFileRequest
 * @iface com.weiyirong99.rms.api.model.request.audit.AuditAddWechatFileRequest
 */
export interface AuditAddWechatFileRequest {
  imgPath: string;
  msgSvrId: Long;
  uploadMeta: OssSignedUrlResponse;
  wxid: string;
}

/**
 * OssSignedUrlResponse$1
 * @iface com.weiyirong99.rms.api.model.response.OssSignedUrlResponse
 */
export interface OssSignedUrlResponse$1 {
  meta?: OssSignedUrlResponse;
  url?: string;
}

/**
 * UserLogListItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.UserLogListItemDTO
 */
export interface UserLogListItemDTO {
  createdAt?: string;
  id?: Long;
  remark?: string;
}

/**
 * ShellLogRequest
 * @iface com.weiyirong99.rms.api.model.request.audit.ShellLogRequest
 */
export interface ShellLogRequest {
  createTime?: Long;
  deviceId?: string;
  endTime?: Long;
  exitCode?: number;
  log?: string;
}

/**
 * UserSmsDTO
 * @iface com.weiyirong99.rms.api.service.dto.UserSmsDTO
 */
export interface UserSmsDTO {
  address?: string;
  body?: string;
  companyId?: Long;
  createdAt?: string;
  id?: Long;
  msgId?: Long;
  smsedAt?: Long;
  type?: number;
  updatedAt?: string;
  user?: BaseUserDTO;
  userId?: Long;
}

/**
 * BaseUserDTO
 * @iface com.weiyirong99.rms.api.service.dto.BaseUserDTO
 */
export interface BaseUserDTO {
  departmentId?: Long;
  id: Long;
  mobile?: string;
  name: string;
  roleId?: Long;
  state: UserStateEnum;
}

/**
 * WechatChatroomDTO
 * @iface com.weiyirong99.rms.api.service.dto.WechatChatroomDTO
 */
export interface WechatChatroomDTO {
  addtime?: string;
  chatroomname?: string;
  chatroomnick?: string;
  createdAt?: string;
  displayname?: string;
  id?: Long;
  memberlist?: string;
  raw?: string;
  roomowner?: string;
  updatedAt?: string;
  user?: BaseUserDTO;
  userId?: Long;
  wxid?: string;
}

/**
 * WechatContactDTO
 * @iface com.weiyirong99.rms.api.service.dto.WechatContactDTO
 */
export interface WechatContactDTO {
  alias?: string;
  avatar?: string;
  conRemark?: string;
  createTime?: string;
  createdAt?: string;
  id?: Long;
  nickname?: string;
  raw?: string;
  type?: number;
  updatedAt?: string;
  user?: BaseUserDTO;
  userId?: Long;
  username?: string;
  wxid?: string;
}

/**
 * PageResponse
 * @iface com.weiyirong99.rms.api.model.response.PageResponse
 */
export interface PageResponse<T> {
  list?: T[];
  page: number;
  size: number;
  total?: number;
}

/**
 * BatchQueryWechatContactRequest
 * @iface com.weiyirong99.rms.api.model.request.audit.BatchQueryWechatContactRequest
 */
export interface BatchQueryWechatContactRequest {
  userId: Long;
  usernames: string[];
  wxid: string;
}

/**
 * WechatFileDTO
 * @iface com.weiyirong99.rms.api.service.dto.WechatFileDTO
 */
export interface WechatFileDTO {
  createdAt?: string;
  fileId?: Long;
  id?: Long;
  imgPath?: string;
  key?: string;
  msgSvrId?: string;
  updatedAt?: string;
  user?: BaseUserDTO;
  userFile?: UserFileDTO;
  userId?: Long;
  wxid?: string;
}

/**
 * UserFileDTO
 * @iface com.weiyirong99.rms.api.service.dto.UserFileDTO
 */
export interface UserFileDTO extends BaseDTO {
  companyId: Long;
  date: string;
  fileFrom: OssFileFromEnum;
  filename: string;
  rawFilename?: string;
  type: OssFileTypeEnum;
  userId: Long;
}

/**
 * WechatMessageDTO
 * @iface com.weiyirong99.rms.api.service.dto.WechatMessageDTO
 */
export interface WechatMessageDTO {
  content?: string;
  createTime?: string;
  createdAt?: string;
  id?: Long;
  imgPath?: string;
  isSend?: number;
  msgId?: Long;
  msgSeq?: number;
  msgSvrId?: string;
  raw?: string;
  status?: number;
  talker?: string;
  talkerId?: Long;
  type?: number;
  updatedAt?: string;
  user?: BaseUserDTO;
  userId?: Long;
  wxid?: string;
}

/**
 * WechatUserDTO
 * @iface com.weiyirong99.rms.api.service.dto.WechatUserDTO
 */
export interface WechatUserDTO {
  avatar?: string;
  companyId?: Long;
  createdAt?: string;
  id?: Long;
  nickname?: string;
  raw?: string;
  status?: number;
  updatedAt?: string;
  user?: BaseUserDTO;
  userId?: Long;
  wxid?: string;
}

/**
 * BatchDropToBlackListParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.BatchDropToBlackListParamsDTO
 */
export interface BatchDropToBlackListParamsDTO {
  customerIdList: Long[];
  remark?: string;
}

/**
 * BlackListItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.BlackListItemDTO
 */
export interface BlackListItemDTO extends BaseDTO {
  channel?: string;
  companyId: Long;
  mobile: string;
  name?: string;
  remark?: string;
  user?: BaseUserDTO;
}

/**
 * ListBlackListParams
 * @iface com.weiyirong99.rms.api.service.dto.ListBlackListParams
 */
export interface ListBlackListParams {
  channel?: string;
  createdAt?: string[];
  keyword?: string;
  userId?: Long;
}

/**
 * DepartmentDTO
 * @iface com.weiyirong99.rms.api.service.dto.DepartmentDTO
 */
export interface DepartmentDTO extends BaseDTO {
  companyId?: Long;
  description?: string;
  name?: string;
  parent?: DepartmentDTO;
}

/**
 * AddDepartmentRequest
 * @iface com.weiyirong99.rms.api.model.request.AddDepartmentRequest
 */
export interface AddDepartmentRequest {
  description?: string;
  name: string;
  parentId?: Long;
}

/**
 * CompanyDTO
 * @iface com.weiyirong99.rms.api.service.dto.CompanyDTO
 */
export interface CompanyDTO extends BaseDTO {
  address?: string;
  config?: CompanyConfig;
  description?: string;
  logoOss?: boolean;
  logoUrl?: string;
  name: string;
  openapiToken?: string;
}

/**
 * CompanyConfig
 * @iface com.weiyirong99.rms.api.dao.entity.companyconfig.CompanyConfig
 */
export interface CompanyConfig {
  appLoginExpiredAtHours?: number;
  autoBlackListFromCompanyIds?: Long[];
  companyRankConfig?: CompanyRankConfig;
  customerStateNameMap?: Record<CustomerStateEnum, string>;
  defaultJoinPublicPoolConfig?: number;
  dingTalkConfig?: DingTalkConfig;
  disableIndexRank?: boolean;
  disableLoginWithoutDeviceId?: boolean;
  disableSMSLogin?: boolean;
  enableAppIPWhite?: boolean;
  enableGroupHomeTop?: boolean;
  enableJoinPublicPool?: boolean;
  enableSignPhoto?: boolean;
  globalCompanyMessageId?: Long;
  hideOutsiderSource?: boolean;
  hideReport?: boolean;
  joinPublicPoolConfig?: Record<CustomerStateEnum, JoinPublicPoolConfig>;
  maxPeekCustomer?: number;
  publicPoolTime?: PublicPoolTime[];
  publicPoolWhiteListUserIdList?: Long[];
  sensitiveWordList?: string[];
  studyTime?: PublicPoolTime[];
  syncFromCompanyIds?: Long[];
  wechatKeywordAlarm?: string[];
  wechatMobileAlarm?: boolean;
  wechatRedPacketAlarm?: boolean;
  whiteIPList?: string[];
}

/**
 * CompanyRankConfig
 * @iface com.weiyirong99.rms.api.dao.entity.companyconfig.CompanyRankConfig
 */
export interface CompanyRankConfig {
  companies?: Record<Long, string>;
  enable?: boolean;
  time?: PublicPoolTime[];
}

/**
 * PublicPoolTime
 * @iface com.weiyirong99.rms.api.dao.entity.companyconfig.PublicPoolTime
 */
export interface PublicPoolTime {
  enable: boolean;
  end: string;
  start: string;
}

/**
 * DingTalkConfig
 * @iface com.weiyirong99.rms.api.dao.entity.companyconfig.DingTalkConfig
 */
export interface DingTalkConfig {
  agentId?: string;
  appKey?: string;
  appSecret?: string;
}

/**
 * JoinPublicPoolConfig
 * @iface com.weiyirong99.rms.api.dao.entity.companyconfig.JoinPublicPoolConfig
 */
export interface JoinPublicPoolConfig {
  day?: number;
}

/**
 * CompanyListItem
 * @iface com.weiyirong99.rms.api.model.config.CompanyListItem
 */
export interface CompanyListItem {
  id: Long;
  name: string;
  url: string;
}

/**
 * BaseDepartmentDTO
 * @iface com.weiyirong99.rms.api.service.dto.BaseDepartmentDTO
 */
export interface BaseDepartmentDTO extends BaseDTO {
  companyId: Long;
  description?: string;
  name: string;
  parentId?: Long;
}

/**
 * CompanyMediaAddDTO
 * @iface com.weiyirong99.rms.api.service.dto.CompanyMediaAddDTO
 */
export interface CompanyMediaAddDTO {
  category?: string;
  items?: CompanyMediaAddItemDTO[];
}

/**
 * CompanyMediaAddItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.CompanyMediaAddItemDTO
 */
export interface CompanyMediaAddItemDTO {
  description?: string;
  head?: boolean;
  key?: string;
  name?: string;
  size?: Long;
  type?: CompanyMediaTypeEnum;
}

/**
 * ListCompanyMediaItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.ListCompanyMediaItemDTO
 */
export interface ListCompanyMediaItemDTO extends BaseDTO {
  category: string;
  companyId: Long;
  count: Long;
  departmentId?: Long;
  description?: string;
  head?: boolean;
  name: string;
  ossKey: string;
  size: Long;
  type: CompanyMediaTypeEnum;
  userId: Long;
  userName?: string;
}

/**
 * CompanyMediaListItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.CompanyMediaListItemDTO
 */
export interface CompanyMediaListItemDTO {
  category: string;
  createdAt: string;
  ossKey: string;
}

/**
 * ListCompanyMediaParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.ListCompanyMediaParamsDTO
 */
export interface ListCompanyMediaParamsDTO {
  category?: string;
  departmentIds?: Long[];
  keyword?: string;
  type?: CompanyMediaTypeEnum;
}

/**
 * CompanyMessageDTO
 * @iface com.weiyirong99.rms.api.service.dto.CompanyMessageDTO
 */
export interface CompanyMessageDTO extends BaseDTO {
  body?: string;
  companyId: Long;
  image: boolean;
  imageKey?: string;
  title: string;
  top: boolean;
  userId: Long;
  userName: string;
}

/**
 * CompanyMessageListItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.CompanyMessageListItemDTO
 */
export interface CompanyMessageListItemDTO extends BaseDTO {
  body?: string;
  companyId: Long;
  image: boolean;
  imageKey?: string;
  title: string;
  top: boolean;
  userId: Long;
  userName: string;
}

/**
 * HomeTopResponse
 * @iface com.weiyirong99.rms.api.service.dto.HomeTopResponse
 */
export interface HomeTopResponse {
  departments?: BaseDepartmentDTO[];
  homeTop?: HomeTopDTO[];
  users?: RMSUserDTO[];
}

/**
 * HomeTopDTO
 * @iface com.weiyirong99.rms.api.service.dto.HomeTopDTO
 */
export interface HomeTopDTO {
  brokerage: Long;
  departmentId?: Long;
  loanAmount: Long;
  loanCount: number;
  userId: Long;
  userName: string;
}

/**
 * RMSUserDTO
 * @iface com.weiyirong99.rms.api.service.dto.RMSUserDTO
 */
export interface RMSUserDTO extends BaseUserDTO {
  newCustomerLimit?: number;
  newCustomerStatus?: boolean;
  selfPause?: boolean;
}

/**
 * RMSCompany
 * @iface com.weiyirong99.rms.api.service.dto.RMSCompany
 */
export interface RMSCompany {
  current?: boolean;
  id?: Long;
  name?: string;
}

/**
 * AddCompanyStudyMediaDTO
 * @iface com.weiyirong99.rms.api.service.dto.AddCompanyStudyMediaDTO
 */
export interface AddCompanyStudyMediaDTO {
  category: string;
  description?: string;
  name: string;
  ossKey: string;
  size: Long;
  type: CompanyStudyMediaTypeEnum;
}

/**
 * ListCompanyStudyMediaItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.ListCompanyStudyMediaItemDTO
 */
export interface ListCompanyStudyMediaItemDTO extends BaseDTO {
  category: string;
  companyId: Long;
  count: Long;
  departmentId?: Long;
  description?: string;
  name: string;
  ossKey: string;
  size: Long;
  type: CompanyStudyMediaTypeEnum;
  userId: Long;
  userName?: string;
}

/**
 * ListCompanyStudyMediaParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.ListCompanyStudyMediaParamsDTO
 */
export interface ListCompanyStudyMediaParamsDTO {
  category?: string;
  departmentIds?: Long[];
  keyword?: string;
  type?: CompanyStudyMediaTypeEnum;
}

/**
 * CustomerEventDTO
 * @iface com.weiyirong99.rms.api.service.dto.CustomerEventDTO
 */
export interface CustomerEventDTO extends BaseDTO {
  comment?: string;
  companyId?: Long;
  customerDTO?: CustomerDTO;
  remark?: string;
  type?: CustomerEventTypeEnum;
  userId?: Long;
}

/**
 * CustomerDTO
 * @iface com.weiyirong99.rms.api.service.dto.CustomerDTO
 */
export interface CustomerDTO extends CustomerBaseDTO {
  aliasName?: string;
  channel?: string;
  companyId: Long;
  count?: number;
  from?: CustomerFromEnum;
  gender?: GenderEnum;
  group?: CustomerGroupEnum;
  loanCount?: number;
  loanSum?: Long;
  mobile: string;
  mobileCity?: string;
  name: string;
  pool: CustomerPoolEnum;
  remark?: string;
  rmsId?: Long;
  score?: number;
  star?: number;
  state?: CustomerStateEnum;
  user?: UserDTO;
}

/**
 * CustomerBaseDTO
 * @iface com.weiyirong99.rms.api.service.dto.CustomerBaseDTO
 */
export interface CustomerBaseDTO extends CustomerBizInfoDTO {
  createdAt: string;
  id: Long;
  updatedAt: string;
}

/**
 * CustomerBizInfoDTO
 * @iface com.weiyirong99.rms.api.service.dto.CustomerBizInfoDTO
 */
export interface CustomerBizInfoDTO {
  hasBusinessLicense?: boolean;
  hasCar?: boolean;
  hasCreditCard?: boolean;
  hasHouse?: boolean;
  hasInsurance?: boolean;
  hasProvidentFund?: boolean;
  hasSocialSecurity?: boolean;
  hasWages?: boolean;
  isNative?: boolean;
}

/**
 * AddCustomerEventRequest
 * @iface com.weiyirong99.rms.api.model.request.AddCustomerEventRequest
 */
export interface AddCustomerEventRequest {
  comment: string;
  remark?: string;
  type: CustomerEventTypeEnum;
}

/**
 * AddCustomerDTO
 * @iface com.weiyirong99.rms.api.service.dto.AddCustomerDTO
 */
export interface AddCustomerDTO extends CustomerBizInfoDTO {
  group: CustomerGroupEnum;
  mobile: string;
  name: string;
  remark?: string;
  star?: number;
  state: CustomerStateEnum;
}

/**
 * CallLogDTO
 * @iface com.weiyirong99.rms.api.service.dto.CallLogDTO
 */
export interface CallLogDTO extends EventDTO {
  duration?: number;
}

/**
 * EventDTO
 * @iface com.weiyirong99.rms.api.service.dto.EventDTO
 */
export interface EventDTO extends BaseDTO {
  comment?: string;
  customerId: Long;
  remark?: string;
  type: CustomerEventTypeEnum;
  userId: Long;
  userName: string;
}

/**
 * CustomerListItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.CustomerListItemDTO
 */
export interface CustomerListItemDTO extends CustomerBaseDTO {
  aliasName?: string;
  channel?: string;
  count?: number;
  events?: EventDTO[];
  from?: CustomerFromEnum;
  gender?: GenderEnum;
  group?: CustomerGroupEnum;
  loanCount?: number;
  loanSum?: Long;
  mobile?: string;
  name: string;
  pool: CustomerPoolEnum;
  remark?: string;
  rmsId?: Long;
  score?: number;
  star?: number;
  state: CustomerStateEnum;
  trace?: TraceDTO;
  userId?: Long;
  userName?: string;
}

/**
 * TraceDTO
 * @iface com.weiyirong99.rms.api.service.dto.TraceDTO
 */
export interface TraceDTO extends BaseDTO {
  assignedAt?: string;
  eventAt?: string;
  handledAt?: string;
  signedAt?: string;
  visitedAt?: string;
}

/**
 * ListCustomerParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.ListCustomerParamsDTO
 */
export interface ListCustomerParamsDTO extends CustomerBizInfoDTO {
  channel?: string;
  channelList?: string[];
  city?: string;
  count?: number;
  createdAt?: string[];
  customerId?: Long;
  departmentIdList?: Long[];
  excludeDepartmentIdList?: boolean;
  excludeUserIdList?: boolean;
  from?: CustomerFromEnum;
  group?: CustomerGroupEnum;
  groupList?: CustomerGroupEnum[];
  handledAt?: string[];
  keyword?: string;
  lastEventAt?: string[];
  pool?: CustomerPoolEnum;
  score?: number;
  signedAt?: string[];
  sorter?: Record<string, SearchSortDirection>;
  star?: number;
  state?: CustomerStateEnum;
  stateList?: CustomerStateEnum[];
  userIdList?: Long[];
  userKeyword?: string;
  visitedAt?: string[];
}

/**
 * CustomerEventListItem
 * @iface com.weiyirong99.rms.api.service.dto.CustomerEventListItem
 */
export interface CustomerEventListItem {
  comment?: string;
  createdAt: string;
  customerId: Long;
  customerName: string;
  departmentId?: Long;
  eventDepartmentId?: Long;
  eventUserId: Long;
  eventUserName: string;
  id: Long;
  mobile: string;
  pool: CustomerPoolEnum;
  remark?: string;
  type: CustomerEventTypeEnum;
  updatedAt: string;
  userId: Long;
  userName: string;
}

/**
 * ListCustomerEventsParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.ListCustomerEventsParamsDTO
 */
export interface ListCustomerEventsParamsDTO {
  departmentId?: Long[];
  endTime?: string;
  eventDepartmentId?: Long[];
  eventUserId?: Long[];
  key?: string;
  pool?: CustomerPoolEnum;
  remark?: string;
  startTime?: string;
  type?: CustomerEventTypeEnum[];
  userId?: Long[];
}

/**
 * CustomerListItemV2DTO
 * @iface com.weiyirong99.rms.api.service.dto.CustomerListItemV2DTO
 */
export interface CustomerListItemV2DTO extends CustomerBaseDTO {
  aliasName?: string;
  channel?: string;
  count?: number;
  from?: CustomerFromEnum;
  gender?: GenderEnum;
  group?: CustomerGroupEnum;
  lastEvent?: EventDTO;
  loanCount?: number;
  loanSum?: Long;
  mobile?: string;
  mobileCity?: string;
  name: string;
  pool: CustomerPoolEnum;
  remark?: string;
  rmsId?: Long;
  score?: number;
  star?: number;
  state: CustomerStateEnum;
  trace?: TraceDTO;
  userId?: Long;
  userName?: string;
}

/**
 * PickCustomerRequest
 * @iface com.weiyirong99.rms.api.model.request.PickCustomerRequest
 */
export interface PickCustomerRequest {
  pickCustomerDTOs: PickCustomerDTO[];
}

/**
 * PickCustomerDTO
 * @iface com.weiyirong99.rms.api.service.PickCustomerDTO
 */
export interface PickCustomerDTO {
  customerId: Long;
  originalUserId: Long;
}

/**
 * MobileLocationDTO
 * @iface com.weiyirong99.rms.api.service.dto.MobileLocationDTO
 */
export interface MobileLocationDTO {
  channel?: string;
  city?: string;
  extra?: Record<string, any>;
  isp?: string;
  mobile?: string;
  province?: string;
}

/**
 * ReAllocateCustomerParams
 * @iface com.weiyirong99.rms.api.service.dto.ReAllocateCustomerParams
 */
export interface ReAllocateCustomerParams {
  customerIds: Long[];
  userId: Long;
}

/**
 * ReAllocateCustomerV2Params
 * @iface com.weiyirong99.rms.api.service.dto.ReAllocateCustomerV2Params
 */
export interface ReAllocateCustomerV2Params {
  pickCustomerDTOS: PickCustomerDTO[];
  userId: Long;
}

/**
 * ChannelAnalyzeDTO
 * @iface com.weiyirong99.rms.api.service.dto.analyze.ChannelAnalyzeDTO
 */
export interface ChannelAnalyzeDTO extends BaseDataAnalyzeDTO {
  channel?: string;
  loan?: LoanChannelAnalyzeDTO;
}

/**
 * BaseDataAnalyzeDTO
 * @iface com.weiyirong99.rms.api.service.dto.analyze.BaseDataAnalyzeDTO
 */
export interface BaseDataAnalyzeDTO {
  cnt: Long;
  star0: Long;
  star1: Long;
  star2: Long;
  star3: Long;
  star4: Long;
  star5: Long;
  stateSignedCount: Long;
  stateVisitedCount: Long;
}

/**
 * LoanChannelAnalyzeDTO
 * @iface com.weiyirong99.rms.api.service.dto.LoanChannelAnalyzeDTO
 */
export interface LoanChannelAnalyzeDTO {
  channel?: string;
  cnt?: Long;
  customerCount?: Long;
  loanAmount?: Long;
  loanBrokerage?: Long;
}

/**
 * ChannelAnalyzeRequest
 * @iface com.weiyirong99.rms.api.model.request.ChannelAnalyzeRequest
 */
export interface ChannelAnalyzeRequest {
  depIds?: Long[];
  end?: string;
  fromEnums?: CustomerFromEnum;
  start?: string;
}

/**
 * CustomerAnalyzeDTO
 * @iface com.weiyirong99.rms.api.service.dto.CustomerAnalyzeDTO
 */
export interface CustomerAnalyzeDTO {
  cnt: Long;
  groupA: Long;
  groupB: Long;
  groupC: Long;
  groupD: Long;
  groupE: Long;
  groupExpand: Long;
  groupLocked: Long;
  groupMortgage: Long;
  groupNewAllot: Long;
  groupNewCustomer: Long;
  star0: Long;
  star1: Long;
  star2: Long;
  star3: Long;
  star4: Long;
  star5: Long;
  stateApproval: Long;
  stateBlackList: Long;
  stateExamining: Long;
  stateInvalid: Long;
  stateLoan: Long;
  stateSigned: Long;
  stateUnknown: Long;
  stateUnqualified: Long;
  stateVisited: Long;
  stateWaitFollowUp: Long;
  stateWaitSign: Long;
  user?: BaseUserDTO;
}

/**
 * HandleAnalyseDTO
 * @iface com.weiyirong99.rms.api.service.dto.HandleAnalyseDTO
 */
export interface HandleAnalyseDTO {
  brokerage: Long;
  callInCount: number;
  callInDuration: number;
  callOutCount: number;
  callOutDuration: number;
  comment: number;
  departmentId?: Long;
  distinctComment: number;
  loanAmount: Long;
  loanCount: number;
  sign: number;
  userId: Long;
  userName: string;
  userState: UserStateEnum;
  visitor: number;
  visitorCurMonth: number;
  withAgent: number;
  withAgentCurMonth: number;
  withAgentSign: number;
}

/**
 * HandleAnalyseParams
 * @iface com.weiyirong99.rms.api.service.dto.HandleAnalyseParams
 */
export interface HandleAnalyseParams {
  currentMonthEnd: string;
  currentMonthStart: string;
  departmentId?: Long;
  end: string;
  start: string;
}

/**
 * MonthlyDataDTO
 * @iface com.weiyirong99.rms.api.service.dto.MonthlyDataDTO
 */
export interface MonthlyDataDTO {
  brokerage?: Long;
  loanAmount?: Long;
  loanCount?: Long;
  month?: number;
  signCount?: Long;
  visitorCount?: Long;
  year?: number;
}

/**
 * LoanAnalyzeDTO
 * @iface com.weiyirong99.rms.api.service.dto.LoanAnalyzeDTO
 */
export interface LoanAnalyzeDTO {
  bank: string;
  brokerage: Long;
  channel: string;
  loanAmount: Long;
  user: BaseUserDTO;
}

/**
 * LoanAnalyzeRequest
 * @iface com.weiyirong99.rms.api.model.request.LoanAnalyzeRequest
 */
export interface LoanAnalyzeRequest {
  end: string;
  start: string;
}

/**
 * MobileTodayAnalyzeDTO
 * @iface com.weiyirong99.rms.api.service.dto.analyze.MobileTodayAnalyzeDTO
 */
export interface MobileTodayAnalyzeDTO {
  callCount?: Long;
  callDuration?: Long;
  callInCount?: Long;
  callInDuration?: Long;
  callOutCount?: Long;
  callOutDuration?: Long;
  eventCount?: Long;
  eventCustomerCount?: Long;
}

/**
 * MobileTotalAnalyzeDTO
 * @iface com.weiyirong99.rms.api.service.dto.analyze.MobileTotalAnalyzeDTO
 */
export interface MobileTotalAnalyzeDTO {
  callCount?: Long;
  callInCount?: Long;
  callOutCount?: Long;
  date?: string;
}

/**
 * NewDataAnalyzeDTO
 * @iface com.weiyirong99.rms.api.service.dto.analyze.NewDataAnalyzeDTO
 */
export interface NewDataAnalyzeDTO extends BaseDataAnalyzeDTO {
  departmentId?: Long;
  userId: Long;
  userName: string;
  userState: UserStateEnum;
  withAgentCount: Long;
  withAgentSignedCount: Long;
  withBrokerage: Long;
  withLoanAmount: Long;
  withLoanCount: Long;
}

/**
 * HomeAnalyseDTO
 * @iface com.weiyirong99.rms.api.service.dto.HomeAnalyseDTO
 */
export interface HomeAnalyseDTO {
  month?: HomeAnalyseItemDTO;
  today?: HomeAnalyseItemDTO;
  week?: HomeAnalyseItemDTO;
  yesterday?: HomeAnalyseItemDTO;
}

/**
 * HomeAnalyseItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.HomeAnalyseItemDTO
 */
export interface HomeAnalyseItemDTO {
  comment?: number;
  day?: number;
  distinctComment?: number;
  loanAmount?: Long;
  loanCount?: number;
  month?: number;
  rmsCustomer?: number;
  userId?: Long;
  visitor?: number;
}

/**
 * SummaryDTO
 * @iface com.weiyirong99.rms.api.service.dto.analyze.summary.SummaryDTO
 */
export interface SummaryDTO {
  event?: EventSummaryDTO;
  loan?: LoanSummaryDTO;
  visitor?: BaseSummaryDatumDTO;
}

/**
 * EventSummaryDTO
 * @iface com.weiyirong99.rms.api.service.dto.analyze.summary.EventSummaryDTO
 */
export interface EventSummaryDTO extends BaseSummaryDatumDTO {
  monthHandleCount: number;
  monthTotal: number;
  todayHandleCount: number;
  todayTotal: number;
  weekHandleCount: number;
  weekTotal: number;
  yesterdayHandleCount: number;
  yesterdayTotal: number;
}

/**
 * BaseSummaryDatumDTO
 * @iface com.weiyirong99.rms.api.service.dto.analyze.summary.BaseSummaryDatumDTO
 */
export interface BaseSummaryDatumDTO {
  month: number;
  today: number;
  week: number;
  yesterday: number;
}

/**
 * LoanSummaryDTO
 * @iface com.weiyirong99.rms.api.service.dto.analyze.summary.LoanSummaryDTO
 */
export interface LoanSummaryDTO extends BaseSummaryDatumDTO {
  monthAmount: Long;
  todayAmount: Long;
  weekAmount: Long;
  yesterdayAmount: Long;
}

/**
 * WelcomeCoreHeaderDataDTO
 * @iface com.weiyirong99.rms.api.service.dto.WelcomeCoreHeaderDataDTO
 */
export interface WelcomeCoreHeaderDataDTO {
  currentMonth: WelcomeCoreDataDTO;
  prevMonth?: WelcomeCoreDataDTO;
}

/**
 * WelcomeCoreDataDTO
 * @iface com.weiyirong99.rms.api.service.dto.WelcomeCoreDataDTO
 */
export interface WelcomeCoreDataDTO {
  brokerage: Long;
  customerCount: Long;
  loanAmount: Long;
  loanCount: Long;
  signCount: Long;
  star0: number;
  star1: number;
  star2: number;
  star3: number;
  star4: number;
  star5: number;
  visitorCount: Long;
}

/**
 * AddLoanDTO
 * @iface com.weiyirong99.rms.api.service.dto.AddLoanDTO
 */
export interface AddLoanDTO {
  bank: string;
  brokerage: Long;
  customerId: Long;
  loanAmount: Long;
  loanedAt: string;
  remark?: string;
  userId: Long;
}

/**
 * CustomerLoanDTO
 * @iface com.weiyirong99.rms.api.service.dto.CustomerLoanDTO
 */
export interface CustomerLoanDTO extends BaseDTO {
  bank?: string;
  brokerage?: Long;
  channel?: string;
  companyId: Long;
  creatorDepartmentId?: Long;
  creatorId: Long;
  creatorName?: string;
  customerCreatedAt?: string;
  customerId: Long;
  customerMobile?: string;
  customerName?: string;
  loanAmount?: Long;
  loanedAt?: string;
  remark?: string;
  userDepartmentId?: Long;
  userId: Long;
  userName?: string;
}

/**
 * ListCustomerLoanParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.ListCustomerLoanParamsDTO
 */
export interface ListCustomerLoanParamsDTO {
  bank?: string;
  channel?: string;
  createdAtBegin?: string;
  createdAtEnd?: string;
  customerKeyword?: string;
  departmentId?: Long;
  loanId?: Long;
  loanedAtBegin?: string;
  loanedAtEnd?: string;
  userId?: Long;
  userIdList?: Long[];
  userKeyword?: string;
}

/**
 * OSSDirectSignature
 * @iface com.weiyirong99.rms.api.service.dto.OSSDirectSignature
 */
export interface OSSDirectSignature {
  accessKey: string;
  dir: string;
  expire: string;
  host: string;
  policy: string;
  signature: string;
}

/**
 * ImportOutsideResponse
 * @iface com.weiyirong99.rms.api.model.response.ImportOutsideResponse
 */
export interface ImportOutsideResponse {
  success?: Long;
  total?: Long;
}

/**
 * OutsideItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.OutsideItemDTO
 */
export interface OutsideItemDTO extends BaseDTO {
  aliasName?: string;
  mobile: string;
  name: string;
  remark?: string;
  star: number;
  state: CustomerStateEnum;
}

/**
 * ListOutsideParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.ListOutsideParamsDTO
 */
export interface ListOutsideParamsDTO {
  createdAt?: string[];
  mobile?: string;
  star?: number;
  state?: CustomerStateEnum;
}

/**
 * OutsideAllocateParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.OutsideAllocateParamsDTO
 */
export interface OutsideAllocateParamsDTO {
  allocation?: OutsideAllocateItemDTO[];
  channel?: string;
  group?: CustomerGroupEnum;
  remark?: string;
}

/**
 * OutsideAllocateItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.OutsideAllocateItemDTO
 */
export interface OutsideAllocateItemDTO {
  outsideIds: Long[];
  userId: Long;
}

/**
 * AddRoleRequest
 * @iface com.weiyirong99.rms.api.model.request.AddRoleRequest
 */
export interface AddRoleRequest {
  description?: string;
  name: string;
  viewRoleId?: Long[];
}

/**
 * SmsBalanceResponse
 * @iface com.weiyirong99.rms.api.model.sms.SmsBalanceResponse
 */
export interface SmsBalanceResponse {
  balance?: Long;
  code?: number;
  message?: string;
}

/**
 * SmsConfig
 * @iface com.weiyirong99.rms.api.model.config.SmsConfig
 */
export interface SmsConfig {
  content?: string;
  gatewayUrl?: string;
  params?: Record<string, string>;
  password?: string;
  templateId?: number;
  userName?: string;
}

/**
 * SmsSendByFilterRequest
 * @iface com.weiyirong99.rms.api.model.sms.SmsSendByFilterRequest
 */
export interface SmsSendByFilterRequest {
  companyId?: Long;
  createdAtEnd?: string;
  createdAtStart?: string;
  pool?: CustomerPoolEnum[];
  star?: number[];
  state?: CustomerStateEnum[];
}

/**
 * SmsSendResponse
 * @iface com.weiyirong99.rms.api.model.sms.SmsSendResponse
 */
export interface SmsSendResponse {
  code?: number;
  message?: string;
  msgId?: Long;
  smsCount?: number;
}

/**
 * SmsSendByIdsRequest
 * @iface com.weiyirong99.rms.api.model.sms.SmsSendByIdsRequest
 */
export interface SmsSendByIdsRequest {
  companyId?: Long;
  customerIds?: Long[];
}

/**
 * CompanyLoginTokenResponse
 * @iface com.weiyirong99.rms.api.model.response.CompanyLoginTokenResponse
 */
export interface CompanyLoginTokenResponse {
  mobile: string;
  nonce: string;
  timestamp: string;
  token: string;
}

/**
 * AutoDropToBlackListConfig
 * @iface com.weiyirong99.rms.api.model.config.AutoDropToBlackListConfig
 */
export interface AutoDropToBlackListConfig {
  enabled?: boolean;
  keyword?: string[];
}

/**
 * CustomerAiProfileConfig
 * @iface com.weiyirong99.rms.api.model.config.CustomerAiProfileConfig
 */
export interface CustomerAiProfileConfig {
  base_url?: string;
  batchSize?: number;
  connectTimeoutMs?: number;
  enabled?: boolean;
  filterCompanyIds?: Long[];
  filterCreatedAtEnd?: string;
  filterCreatedAtStart?: string;
  filterPools?: string[];
  filterStars?: number[];
  filterStates?: string[];
  filterUserIds?: Long[];
  key?: string;
  maxRetryCount?: number;
  maxTokens?: number;
  model?: string;
  parallelism?: number;
  promptTemplate?: string;
  readTimeoutMs?: number;
  resultFormatVersion?: string;
  stopHour?: number;
  systemPrompt?: string;
  temperature?: number;
}

/**
 * CustomerAiProfileTaskEntity
 * @iface com.weiyirong99.rms.api.dao.entity.CustomerAiProfileTaskEntity
 */
export interface CustomerAiProfileTaskEntity extends BaseEntity {
  companyId?: Long;
  errorMessage?: string;
  finishedAt?: string;
  maxRetryCount?: number;
  mobile?: string;
  nextRetryAt?: string;
  promptVersion?: string;
  resultJson?: string;
  retryCount?: number;
  startedAt?: string;
  status?: number;
  version?: Long;
}

/**
 * BaseEntity
 * @iface com.weiyirong99.rms.api.dao.entity.BaseEntity
 */
export interface BaseEntity {
  createdAt?: string;
  id?: Long;
  updatedAt?: string;
}

/**
 * CustomerAiProfileTaskService
 * @iface com.weiyirong99.rms.api.service.impl.CustomerAiProfileTaskService$TaskProgressDTO
 */
export interface CustomerAiProfileTaskService {
  failed: Long;
  pending: Long;
  running: Long;
  success: Long;
  total: Long;
}

/**
 * InvalidCustomerEventDTO
 * @iface com.weiyirong99.rms.api.model.config.InvalidCustomerEventDTO
 */
export interface InvalidCustomerEventDTO {
  autoCleanEventTypes?: CustomerEventTypeEnum[];
  autoCleanInvalidCommentSize?: boolean;
  comments?: string[];
  days?: number;
  enabled?: boolean;
  invalidCommentSize?: Long;
}

/**
 * AddCallLogParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.AddCallLogParamsDTO
 */
export interface AddCallLogParamsDTO {
  callId?: Long;
  calledAt?: Long;
  duration?: number;
  mobile?: string;
  type?: CallLogTypeEnum;
}

/**
 * AddUserRequest
 * @iface com.weiyirong99.rms.api.model.request.AddUserRequest
 */
export interface AddUserRequest {
  departmentId: Long;
  ignoreCompany?: boolean;
  mobile: string;
  name: string;
  roleId: Long;
  state?: UserStateEnum;
}

/**
 * UserCountAllNewCustomerLimitResponse
 * @iface com.weiyirong99.rms.api.model.response.UserCountAllNewCustomerLimitResponse
 */
export interface UserCountAllNewCustomerLimitResponse {
  count: number;
  countAvailable: number;
}

/**
 * ListUserV2Params
 * @iface com.weiyirong99.rms.api.service.dto.ListUserV2Params
 */
export interface ListUserV2Params {
  companyId: Long;
  departmentIds?: Long[];
  ignoreCompany?: boolean;
  loginWithoutSMS?: boolean;
  name?: string;
  onlyRootedDevice?: boolean;
  onlyWechat?: boolean;
  roleId?: Long;
  userStates?: UserStateEnum;
  vacation?: boolean;
}

/**
 * GetUserInfoDTO
 * @iface com.weiyirong99.rms.api.service.dto.GetUserInfoDTO
 */
export interface GetUserInfoDTO extends BaseDTO {
  companyId?: Long;
  departmentId?: Long;
  isSuperAdmin?: boolean;
  mobile: string;
  name: string;
  roleId?: Long;
  state: UserStateEnum;
}

/**
 * UserMessageListItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.UserMessageListItemDTO
 */
export interface UserMessageListItemDTO extends BaseDTO {
  body: string;
  extra?: string;
  isRead: boolean;
  title?: string;
  userId: Long;
}

/**
 * ListUserItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.ListUserItemDTO
 */
export interface ListUserItemDTO extends BaseDTO {
  appOnline: boolean;
  appRegisterId?: string;
  companyId?: Long;
  departmentId?: Long;
  isSuperAdmin: boolean;
  lastIP?: string;
  lastIPAddress?: string;
  lastLoginAt?: string;
  loginWithoutSMS: boolean;
  mobile: string;
  name: string;
  newCustomerLimit?: number;
  newCustomerStatus?: boolean;
  passwordLastUpdatedAt?: string;
  pcOnline: boolean;
  roleId?: Long;
  selfPause?: boolean;
  state: UserStateEnum;
  userDevice?: UserDeviceDTO[];
  vacation: boolean;
}

/**
 * UserDeviceDTO
 * @iface com.weiyirong99.rms.api.service.dto.UserDeviceDTO
 */
export interface UserDeviceDTO extends BaseDTO {
  appVersion?: string;
  deviceId?: string;
  mobileMode?: string;
  mobileVersion?: string;
  permissions?: string;
  rooted?: boolean;
  userId?: Long;
}

/**
 * ListUserItemV3DTO
 * @iface com.weiyirong99.rms.api.service.dto.ListUserItemV3DTO
 */
export interface ListUserItemV3DTO extends ListUserItemDTO {
  wxid?: string[];
}

/**
 * ListUserV3Params
 * @iface com.weiyirong99.rms.api.service.dto.ListUserV3Params
 */
export interface ListUserV3Params {
  companyId: Long;
  departmentIds?: Long[];
  name?: string;
}

/**
 * SwitchUserResponse
 * @iface com.weiyirong99.rms.api.model.response.SwitchUserResponse
 */
export interface SwitchUserResponse {
  token: string;
}

/**
 * UpdateUserConfigDTO
 * @iface com.weiyirong99.rms.api.service.UpdateUserConfigDTO
 */
export interface UpdateUserConfigDTO {
  appRegisterId?: string;
  loginWithoutSMS?: boolean;
  newCustomerLimit?: number;
  newCustomerStatus?: boolean;
  selfPause?: boolean;
}

/**
 * UserFeedbackListItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.UserFeedbackListItemDTO
 */
export interface UserFeedbackListItemDTO extends BaseDTO {
  anon?: boolean;
  body: string;
  depId?: Long;
  roleId?: Long;
  userId: Long;
  userName: string;
}

/**
 * VisitorListItemDTO
 * @iface com.weiyirong99.rms.api.service.dto.VisitorListItemDTO
 */
export interface VisitorListItemDTO extends BaseDTO {
  agentMobile?: string;
  agentName?: string;
  amount?: number;
  channel?: string;
  contractId?: string;
  customerCreateTime?: string;
  isSign?: boolean;
  liability?: string;
  oid?: Long;
  point?: number;
  qualification?: string;
  remark?: string;
  user: BaseUserDTO;
  visitorMobile: string;
  visitorName: string;
  withContractImg?: boolean;
  withSignImg?: boolean;
}

/**
 * ListVisitorParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.ListVisitorParamsDTO
 */
export interface ListVisitorParamsDTO {
  agentKeyword?: string;
  channel?: string;
  createdAt?: string[];
  customerCreateTime?: string[];
  departmentId?: Long;
  departmentIds?: Long[];
  isSign?: boolean;
  userId?: Long;
  userIdList?: Long[];
  userKeyword?: string;
  visitorKeyword?: string;
  withAgent?: boolean;
}

/**
 * UpdateVisitorParamsDTO
 * @iface com.weiyirong99.rms.api.service.dto.UpdateVisitorParamsDTO
 */
export interface UpdateVisitorParamsDTO {
  agentMobile?: string;
  agentName?: string;
  amount?: number;
  contractId?: string;
  isSign?: boolean;
  liability?: string;
  point?: number;
  qualification?: string;
  remark?: string;
  visitorMobile: string;
  visitorName: string;
}

/**
 * OpenAPICreateCustomerResponse
 * @iface com.weiyirong99.rms.api.model.response.OpenAPICreateCustomerResponse
 */
export interface OpenAPICreateCustomerResponse {
  inBlackList?: boolean;
  reApply?: boolean;
  userId?: Long;
}

/**
 * CreateCustomerRequest
 * @iface com.weiyirong99.rms.api.model.request.openapi.CreateCustomerRequest
 */
export interface CreateCustomerRequest {
  bizInfo?: CustomerBizInfoDTO;
  channel: string;
  loanAmount?: Long;
  mobile: string;
  mode?: RepetitionPushModeEnum;
  name: string;
  props?: Record<string, any>;
  remark?: string;
  rmsId: Long;
  userId: Long;
}

/**
 * OpenAPICustomerBasicModel
 * @iface com.weiyirong99.rms.api.model.response.OpenAPICustomerBasicModel
 */
export interface OpenAPICustomerBasicModel {
  id?: Long;
  mobile?: string;
  star?: number;
  state?: CustomerStateEnum;
}

/**
 * OpenAPICustomerEvenDTO
 * @iface com.weiyirong99.rms.api.model.response.OpenAPICustomerEvenDTO
 */
export interface OpenAPICustomerEvenDTO {
  comment?: string;
  createdAt?: string;
  mobile?: string;
  remark?: string;
  type?: CustomerEventTypeEnum;
  updatedAt?: string;
}

/**
 * SyncCustomersRequest
 * @iface com.weiyirong99.rms.api.model.request.openapi.SyncCustomersRequest
 */
export interface SyncCustomersRequest {
  customerMobiles?: string[];
}

/**
 * OpenAPISyncStatusResponse
 * @iface com.weiyirong99.rms.api.model.response.OpenAPISyncStatusResponse
 */
export interface OpenAPISyncStatusResponse {
  synced: Long;
  total: Long;
}

/**
 * OpenapiCustomerDTO
 * @iface com.weiyirong99.rms.api.service.dto.OpenapiCustomerDTO
 */
export interface OpenapiCustomerDTO {
  id?: Long;
  lastEvent?: EventDTO;
  mobile?: string;
  rmsId?: Long;
  star?: number;
  state?: CustomerStateEnum;
}

/**
 * MQTTAuthResponse
 * @iface com.weiyirong99.rms.api.model.response.MQTTAuthResponse
 */
export interface MQTTAuthResponse {
  acl?: MQTTAuthResponse$1[];
  client_attrs?: Record<string, string>;
  result: MQTTAuthResponse$3;
}

/**
 * MQTTAuthResponse$1
 * @iface com.weiyirong99.rms.api.model.response.MQTTAuthResponse$ACL
 */
export interface MQTTAuthResponse$1 {
  action?: MQTTAuthResponse$2;
  permission?: MQTTAuthResponse$3;
  qos?: number[];
  topic?: string;
}

/**
 * MQTTAuthRequest
 * @iface com.weiyirong99.rms.api.model.request.MQTTAuthRequest
 */
export interface MQTTAuthRequest {
  mobile: string;
  password: string;
}

export enum ApplicationTypeEnum {
  LOAN = 'LOAN',
  ACTUAL_PAY = 'ACTUAL_PAY',
}

export enum CustomerFromEnum {
  RMS = 'RMS',
  OUTSIDER = 'OUTSIDER',
  MANUAL = 'MANUAL',
  VISIT = 'VISIT',
  CRM = 'CRM',
}

export enum CustomerGroupEnum {
  NEW_CUSTOMER = 'NEW_CUSTOMER', // desc=新客户
  A = 'A', // desc=A
  B = 'B', // desc=B
  C = 'C', // desc=C
  D = 'D', // desc=D
  E = 'E', // desc=E
  NEW_ALLOT = 'NEW_ALLOT', // desc=新分派
  EXPAND = 'EXPAND', // desc=拓展
  MORTGAGE = 'MORTGAGE', // desc=抵押
  LOCKED = 'LOCKED', // desc=锁定
}

export enum CustomerStateEnum {
  UNKNOWN = 'UNKNOWN', // desc=未知
  WAIT_FOLLOW_UP = 'WAIT_FOLLOW_UP', // desc=待跟进
  UNQUALIFIED = 'UNQUALIFIED', // desc=贷款资质不符合
  WAIT_SIGN = 'WAIT_SIGN', // desc=待签约
  SIGNED = 'SIGNED', // desc=已签约
  VISITED = 'VISITED', // desc=已上门
  APPROVAL = 'APPROVAL', // desc=审核中
  LOAN = 'LOAN', // desc=银行已放款
  EXAMINING = 'EXAMINING', // desc=在审件
  INVALID = 'INVALID', // desc=捣乱申请
  BLACK_LIST = 'BLACK_LIST', // desc=黑名单
}

export enum PermissionTypeEnum {
  MENU = 'MENU',
  API = 'API',
  STATIC = 'STATIC',
  BUTTON = 'BUTTON',
  VIEW = 'VIEW',
  EDIT = 'EDIT',
}

export enum CustomerEventTypeEnum {
  COMMENT = 'COMMENT', // desc=备注
  DROP_PUBLIC_POOL = 'DROP_PUBLIC_POOL', // desc=抛入公共池
  BLOCK_CALL = 'BLOCK_CALL', // desc=未接通
  CALL = 'CALL', // desc=打电话
  REASSIGN = 'REASSIGN', // desc=重新分派
  VISIT = 'VISIT', // desc=上门
  LOAN = 'LOAN', // desc=放款
  REDUPLICATE = 'REDUPLICATE', // desc=重复申请
  REMARK = 'REMARK', // desc=点评
  INTO_BIZ = 'INTO_BIZ', // desc=进入业务池
}

export enum UserStateEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
}

export enum AuditFileTypeEnum {
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  FILE = 'FILE',
}

export enum OssFileFromEnum {
  CALL = 'CALL',
  WECHAT = 'WECHAT',
}

export enum OssFileTypeEnum {
  VOICE = 'VOICE',
  IMAGE = 'IMAGE',
  FILE = 'FILE',
  VIDEO = 'VIDEO',
  OTHER = 'OTHER',
  PARSED_AUDIO = 'PARSED_AUDIO',
}

export enum CompanyMediaTypeEnum {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
}

export enum CompanyStudyMediaTypeEnum {
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
}

export enum GenderEnum {
  WOMEN = 'WOMEN',
  MAN = 'MAN',
}

export enum CustomerPoolEnum {
  BIZ = 'BIZ',
  PUBLIC = 'PUBLIC',
  WAIT_HANDLE = 'WAIT_HANDLE',
  IDLE = 'IDLE',
}

export enum SearchSortDirection {
  ASC = 'ascend', // value=ascend
  DESC = 'descend', // value=descend
}

export enum ListCustomerType {
  MY = 'MY',
  POOL = 'POOL',
}

export enum StarDetailQueryTypeEnum {
  LOAN = 'LOAN',
  VISIT = 'VISIT',
  SIGNED = 'SIGNED',
  EXTEND = 'EXTEND',
  EXTEND_SIGNED = 'EXTEND_SIGNED',
}

export enum CallLogTypeEnum {
  OUT = 'OUT',
  IN = 'IN',
}

export enum RepetitionPushModeEnum {
  NONE = 'NONE',
  ALL = 'ALL',
  PART = 'PART',
}

export enum MQTTAuthResponse$2 {
  subscribe = 'subscribe',
  publish = 'publish',
  all = 'all',
}

export enum MQTTAuthResponse$3 {
  allow = 'allow',
  deny = 'deny',
  ignore = 'ignore',
}

export type Long = string | number;

export type MultipartFile = Blob | File | string;
